export default {
  // Common
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    search: 'Rechercher',
    filter: 'Filtrer',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    confirm: 'Confirmer',
    close: 'Fermer',
    yes: 'Oui',
    no: 'Non',
    actions: 'Actions',
    status: 'Statut',
    date: 'Date',
    name: 'Nom',
    description: 'Description',
    type: 'Type',
    download: 'Télécharger',
    upload: 'Téléverser',
    copy: 'Copier',
    copied: 'Copié !',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    info: 'Informations',
    all: 'Tout',
    allTypes: 'Tous les types',
    allStatuses: 'Tous les statuts',
    none: 'Aucun',
    active: 'Actif',
    inactive: 'Inactif',
    enabled: 'Activé',
    disabled: 'Désactivé',
    refresh: 'Actualiser',
    back: 'Retour',
    goBack: 'Retour au tableau de bord',
    next: 'Suivant',
    previous: 'Précédent',
    finish: 'Terminer',
    submit: 'Soumettre',
    confirmDeleteItem: 'Voulez-vous supprimer cet élément\u202F?',
    validateForReport: 'Valider pour rapport',
    reset: 'Réinitialiser',
    view: 'Voir',
    details: 'Détails',
    more: 'Plus',
    less: 'Moins',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois',
    optional: 'Optionnel',
    unknown: 'Inconnu',
    notDetected: 'Non détecté',
    notDetectedFeminine: 'Non détectée',
    notAvailable: 'Non disponible',
    required: 'Requis',
    requiredFields: 'Champs obligatoires',
    note: 'Note :',
    and: 'et',
    andThe: 'et les',
    or: 'ou',
    sending: 'Envoi...',
    redirecting: 'Redirection...',
    copyright: '© 2026 SYLink. Tous droits réservés.',
    add: 'Ajouter',
    execute: 'Exécuter',
    launch: 'Lancer',
    pause: 'Pause',
    generating: 'Génération...',
    regenerate: 'Régénérer'
  },

  // APT Modules
  apt: {
    dangerousModule: 'Module dangereux - Utiliser avec précaution',
    addToChain: 'Ajouter à une chaîne',
    createChain: 'Créer une chaîne d\'attaque',
    createChainButton: 'Créer la chaîne',
    chainName: 'Nom de la chaîne',
    selectedModules: 'Modules sélectionnés',
    addModulesFromList: 'Ajoutez des modules depuis la liste à droite',
    availableModules: 'Modules disponibles',
    newChain: 'Nouvelle chaîne',
    executeModule: 'Exécuter {name}',
    loadError: 'Erreur lors du chargement des données APT',
    requiredParams: 'Paramètres requis',
    executions: 'Exécutions',
    successful: 'réussies',
    avgTime: 'Temps moyen',
    modulesApt: 'Modules APT',
    chains: 'Chaînes',
    evidence: 'Preuves',
    mitreMatrix: 'Matrice MITRE ATT&CK',
    category: 'Catégorie',
    criticality: 'Criticité',
    mitreTactic: 'Tactique MITRE',
    allCategories: 'Toutes',
    allCriticalities: 'Toutes',
    allTactics: 'Toutes',
    low: 'Faible',
    medium: 'Moyen',
    high: 'Élevé',
    critical: 'Critique',
    noModulesAvailable: 'Aucune campagne APT disponible pour le moment',
    noModulesFiltered: 'Aucun module ne correspond aux filtres sélectionnés',
    noChains: 'Aucune chaîne d\'attaque créée. Créez-en une pour commencer.',
    noEvidence: 'Aucune preuve collectée. Exécutez des modules pour collecter des preuves.',
    chainStatus: 'Statut',
    chainProgress: 'Progression',
    chainModules: 'Modules',
    chainCreatedAt: 'Créée le',
    executeChain: 'Exécuter {name}',
    moduleLaunched: 'Module {name} lancé',
    moduleLaunchError: 'Erreur lors du lancement du module',
    chainCreated: 'Chaîne créée avec succès',
    chainCreateError: 'Erreur lors de la création de la chaîne',
    chainLaunched: 'Chaîne lancée',
    chainLaunchError: 'Erreur lors du lancement de la chaîne',
    chainPaused: 'Chaîne mise en pause',
    chainCancelled: 'Chaîne annulée',
    dangerWarning: 'Ce module est marqué comme dangereux. Utilisez-le avec précaution.',
    modulesAvailable: 'modules disponibles',
    target: 'Cible',
    duration: 'Durée',
    result: 'Résultat',
    title: 'Titre',
    classification: 'Classification',
    size: 'Taille',
    validated: 'Validé',
    searchPlaceholder: 'Rechercher...',
    tool: 'Outil',
    module: 'Module',
    exitCode: 'Code de sortie',
    status: {
      pending: 'En attente',
      queued: 'En file',
      running: 'En cours',
      paused: 'En pause',
      completed: 'Terminé',
      failed: 'Échoué',
      cancelled: 'Annulé',
      draft: 'Brouillon',
      ready: 'Prêt'
    },
    categories: {
      reconnaissance: 'Reconnaissance',
      resource_development: 'Développement de ressources',
      initial_access: 'Accès initial',
      execution: 'Exécution',
      persistence: 'Persistance',
      privilege_escalation: 'Élévation de privilèges',
      defense_evasion: 'Évasion de défenses',
      credential_access: 'Accès aux identifiants',
      discovery: 'Découverte',
      lateral_movement: 'Mouvement latéral',
      collection: 'Collecte',
      command_and_control: 'Commande et contrôle',
      exfiltration: 'Exfiltration',
      impact: 'Impact'
    },
    criticalities: {
      low: 'Faible',
      medium: 'Moyen',
      high: 'Élevé',
      critical: 'Critique'
    }
  },

  // Navigation
  nav: {
    dashboard: 'Accueil',
    scans: 'Scans',
    workspaces: 'Espaces de travail',
    vulnerabilities: 'Vulnérabilités',
    reports: 'Rapports',
    settings: 'Paramètres',
    account: 'Mon compte',
    logout: 'Déconnexion',
    help: 'Aide',
    admin: 'Administration',
    tools: 'Outils',
    compliance: 'Conformité',
    notifications: 'Notifications',
    credentials: 'Identifiants',
    ad: 'Active Directory',
    sessions: 'Sessions',
    agents: 'Agents'
  },

  // Auth
  auth: {
    login: 'Connexion',
    logout: 'Déconnexion',
    register: 'S\'inscrire',
    email: 'E-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    forgotPassword: 'Mot de passe oublié\u202F?',
    magicLink: 'Lien magique',
    resetPassword: 'Réinitialiser le mot de passe',
    resetPasswordNeedsLink: 'Pour réinitialiser votre mot de passe, utilisez le lien envoyé par e-mail. Vous pouvez demander un nouveau lien depuis la page de connexion.',
    rememberMe: 'Se souvenir de moi',
    loginSuccess: 'Connexion réussie',
    loginError: 'Identifiants incorrects',
    logoutSuccess: 'Déconnexion réussie',
    sessionExpired: 'Session expirée',
    twoFactor: 'Authentification à deux facteurs',
    enterCode: 'Entrez le code',
    verifyCode: 'Vérifier le code',
    invalidCode: 'Code invalide',
    // Register page
    createAccount: 'Créer un compte',
    fillFormBelowEmail: 'Remplissez le formulaire ci-dessous pour créer votre compte entreprise.',
    companyName: 'Nom de l\'entreprise',
    companyPlaceholder: 'Votre entreprise',
    firstName: 'Prénom',
    firstNamePlaceholder: 'Votre prénom',
    lastName: 'Nom',
    lastNamePlaceholder: 'Votre nom',
    professionalEmail: 'E-mail professionnel',
    professionalEmailPlaceholder: 'jean@entreprise.fr',
    professionalPhone: 'Téléphone professionnel',
    phonePlaceholder: '+33 6 12 34 56 78',
    phoneFormatHint: 'Le préfixe +33 est pré-rempli automatiquement. Format\u202F: +33 6 12 34 56 78',
    passwordEmailNote: 'Vous définirez votre mot de passe après validation de votre e-mail.',
    acceptTermsPrefix: 'J\'accepte les',
    createMyAccount: 'Créer mon compte',
    registering: 'Inscription...',
    alreadyHaveAccount: 'Déjà un compte\u202F?',
    loginButton: 'Se connecter',
    byRegistering: 'En créant un compte, vous acceptez nos conditions d\'utilisation et notre politique de confidentialité.',
    registrationSuccess: 'Inscription réussie !',
    registrationEmailSent: 'Un e-mail de confirmation a été envoyé à',
    clickLinkToSetPassword: 'Cliquez sur le lien pour définir votre mot de passe et activer votre compte.',
    checkSpam: 'Vérifiez vos spams si vous ne voyez pas l\'e-mail.',
    backToLogin: 'Retour à la connexion',
    // Login page
    welcomeBack: 'Bon retour !',
    enterCredentials: 'Entrez vos identifiants pour accéder à votre espace.',
    loggingIn: 'Connexion...',
    noAccount: 'Pas encore de compte\u202F?',
    createAccountLink: 'Créer un compte',
    // Email verification
    verifying: 'Vérification en cours...',
    verifyingDescription: 'Veuillez patienter pendant que nous vérifions votre adresse e-mail.',
    emailVerified: 'E-mail vérifié !',
    accountActive: 'Votre compte est maintenant actif.',
    welcome: 'Bienvenue sur SYLink !',
    choosePlan: 'Choisir mon plan',
    redirectingToPlan: 'Redirection vers les tarifs dans {seconds} secondes...',
    orLoginDirectly: 'Ou {loginLink} directement',
    verificationFailed: 'Échec de la vérification',
    needNewVerificationLink: 'Besoin d\'un nouveau lien de vérification\u202F?',
    yourEmail: 'Votre e-mail',
    emailSent: 'E-mail envoyé !',
    resendLink: 'Renvoyer le lien',
    invalidLink: 'Lien invalide',
    requestNewVerificationLink: 'Demander un nouveau lien de vérification',
    sendLink: 'Envoyer le lien',
    // Password reset / Forgot password modal
    resetPasswordTitle: 'Réinitialiser le mot de passe',
    resetPasswordDesc: 'Entrez votre e-mail pour recevoir un lien de réinitialisation.',
    sendResetLink: 'Envoyer le lien',
    forgotPasswordModalTitle: 'Mot de passe oublié\u202F?',
    emailSentTitle: 'E-mail envoyé',
    checkYourInbox: 'Vérifiez votre boîte mail',
    ifAccountExistsPrefix: 'Si un compte existe avec l\'adresse',
    ifAccountExistsSuffix: ', vous recevrez un lien pour réinitialiser votre mot de passe.',
    linkExpiresCheckSpam: 'Le lien expirera dans 24 heures. Pensez à vérifier vos spams.',
    enterEmailForResetLink: 'Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    emailAddressLabel: 'Adresse e-mail',
    sendResetLinkFull: 'Envoyer le lien de réinitialisation',
    sendingInProgress: 'Envoi en cours...',
    connectionError: 'Erreur de connexion. Veuillez réessayer.',
    sending: 'Envoi...',
    resetLinkSent: 'Lien envoyé !',
    resetLinkSentDesc: 'Vérifiez votre boîte mail pour réinitialiser votre mot de passe.',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le mot de passe',
    setNewPassword: 'Définir le mot de passe',
    passwordUpdated: 'Mot de passe mis à jour !',
    passwordUpdatedDesc: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
    // Reset password page
    passwordGenerator: 'Générateur de mot de passe',
    regenerate: 'Régénérer',
    classic: 'Classique',
    quantumResistant: 'Quantum-Résistant',
    quantumSecurityDescription: 'Sécurité maximale contre les attaques quantiques futures',
    passwordChanged: 'Mot de passe modifié !',
    passwordResetSuccess: 'Votre mot de passe a été réinitialisé avec succès. Vous allez être redirigé vers la page de connexion.',
    chooseSecurePassword: 'Choisissez un mot de passe sécurisé pour votre compte',
    orEnterManually: 'ou entrez manuellement',
    newPasswordPlaceholder: 'Entrez votre nouveau mot de passe',
    confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
    minChars: '8 caractères min',
    uppercase: '1 majuscule',
    lowercase: '1 minuscule',
    number: '1 chiffre',
    specialChar: '1 caractère spécial',
    passwordsMatch: 'Mots de passe identiques',
    resettingPassword: 'Réinitialisation...',
    charactersCount: '{count} caractères',
    // Login page additional
    loginSubtitle: 'Connectez-vous pour accéder à votre espace de sécurité.',
    emailNotVerified: 'E-mail non vérifié',
    emailNotVerifiedMessage: 'Veuillez vérifier votre boîte mail et cliquer sur le lien de confirmation.',
    verificationEmailSent: 'E-mail de vérification envoyé !',
    resendVerificationLink: 'Renvoyer l\'e-mail de vérification',
    accountBlocked: 'Compte bloqué',
    personalEmailBlockedMessage: 'Ce compte utilise une adresse e-mail personnelle qui n\'est plus acceptée.',
    securityPolicy: 'Politique de sécurité :',
    professionalEmailOnly: 'Seules les adresses e-mail professionnelles sont autorisées.',
    personalEmailsNotAccepted: 'Les e-mails personnels (Gmail, Hotmail, Yahoo, etc.) ne sont pas acceptés.',
    createNewAccountMessage: 'Pour continuer, créez un nouveau compte avec votre e-mail professionnel :',
    createAccountWithProfessionalEmail: 'Créer un compte avec e-mail professionnel',
    needHelp: 'Besoin d\'aide\u202F? Contactez-nous',
    emailOrUsername: 'Adresse e-mail',
    emailPlaceholder: 'votre-email@exemple.fr',
    passwordPlaceholder: 'Mot de passe',
    createFreeAccount: 'Créer un compte gratuit'
  },

  // Dashboard
  dashboard: {
    title: 'Tableau de bord',
    welcome: 'Bienvenue, {name}',
    overview: 'Vue d\'ensemble',
    recentScans: 'Scans récents',
    recentActivity: 'Activité récente',
    statistics: 'Statistiques',
    quickActions: 'Actions Rapides',
    newScan: 'Nouveau scan',
    viewAllScans: 'Voir tous les scans',
    totalScans: 'Total des scans',
    activeScans: 'Scans en cours',
    completedScans: 'Scans terminés',
    failedScans: 'Scans échoués',
    vulnerabilitiesFound: 'Vulnérabilités trouvées',
    criticalVulns: 'Vulnérabilités critiques',
    highVulns: 'Vulnérabilités hautes',
    mediumVulns: 'Vulnérabilités moyennes',
    lowVulns: 'Vulnérabilités basses',
    systemHealth: 'Santé du système',
    toolsStatus: 'État des outils',
    cpuUsage: 'Utilisation CPU',
    memoryUsage: 'Utilisation mémoire',
    diskUsage: 'Utilisation disque',
    monitoring: 'Surveillance et analyse de sécurité en temps réel',
    critical: 'crit',
    serverPerformance: 'Performances serveur',
    realtimeMonitoring: 'Monitoring temps réel des ressources système',
    online: 'En ligne',
    uptime: 'Temps de fonctionnement',
    activeProcesses: 'Processus actifs',
    scansToday: 'Scans aujourd\'hui',
    networkLoad: 'Charge réseau',
    temperature: 'Température',
    started: 'Démarré',
    noActiveScans: 'Aucun scan actif. Démarrez un nouveau scan pour commencer.',
    noRecentActivity: 'Aucune activité récente.',
    startAssessment: 'Démarrer une évaluation de sécurité',
    exportResults: 'Exporter les résultats des scans',
    // Service status
    services: {
      backendApi: 'Serveur Backend',
      frontend: 'Interface',
      postgresql: 'PostgreSQL',
      aiModels: 'Modèles IA'
    },
    serviceStatus: {
      online: 'En ligne',
      offline: 'Hors ligne',
      checking: 'Vérification',
      degraded: 'Dégradé'
    },
    attackTools: {
      reconnaissance: 'Reconnaissance',
      exploitation: 'Exploitation',
      bruteForce: 'Brute Force',
      postExploitation: 'Post-Exploitation',
      privilegeEscalation: 'Élévation de privilèges'
    },
    targets: {
      webApps: 'Applications Web',
      servers: 'Serveurs',
      databases: 'Bases de données',
      network: 'Réseau',
      networkDevices: 'Routeurs, switches',
      target: 'Cible'
    },
    resources: {
      high: 'Élevé',
      medium: 'Moyen',
      normal: 'Normal',
      critical: 'Critique',
      optimal: 'Optimal',
      active: 'Actif',
      inUse: 'Utilisé',
      idle: 'En attente',
      notDetected: 'Non détecté',
      gpuNotAvailable: 'GPU non disponible',
      aiDisabled: 'IA désactivée',
      cores: 'cœurs',
      multiCore: 'Multi-cœurs',
      systemLoad: 'Charge système',
      used: 'utilisés',
      calculating: 'Calcul...',
      total: 'total',
      totalCores: 'Cœurs totaux',
      totalMemory: 'RAM totale',
      computePower: 'Puissance calcul',
      ramCapacity: 'Capacité mémoire',
      aiCapacity: 'Capacité IA',
      availableTotal: 'Disponible / Total',
      cpuCores: 'Cœurs CPU',
      ramInfra: 'RAM Infra.',
      gpuVram: 'VRAM GPU',
      aiReady: 'IA Prête',
      temperatureOk: 'OK',
      servers: 'serveurs',
      onlineCount: 'en ligne',
      offlineCount: 'hors ligne',
      gpuOnline: 'GPU en ligne',
      model: 'modèle'
    },
    infrastructureTotal: 'Infrastructure totale'
  },

  // Equipment
  equipment: {
    title: 'Gestion des équipements',
    subtitle: 'Détectez, catégorisez et attaquez les équipements du réseau',
    totalEquipment: 'Total Équipements',
    totalEquipmentDesc: 'Nombre total d\'équipements enregistrés dans la base de données. Inclut serveurs, postes de travail, équipements réseau, IoT, OT/ICS et autres dispositifs identifiés.',
    equipmentLabel: 'équipements',
    totalAttacks: 'Total Attaques',
    attacksLabel: 'attaques',
    successfulAttacks: 'Attaques réussies',
    successfulAttacksLabel: 'réussies',
    ongoingAttacks: 'Attaques en cours',
    ongoingAttacksLabel: 'en cours',
    typesTab: 'Types d\'équipements',
    detectedTab: 'Équipements détectés',
    attacksTab: 'Attaques',
    autoDetect: 'Auto-Détecter',
    refresh: 'Actualiser',
    searchPlaceholder: 'Rechercher…',
    category: 'Catégorie',
    allCategories: 'Toutes'
  },

  // Scans
  scans: {
    title: 'Scans',
    newScan: 'Nouveau scan',
    scanHistory: 'Historique des scans',
    target: 'Cible',
    targets: 'Cibles',
    scanType: 'Type de scan',
    startScan: 'Démarrer le scan',
    stopScan: 'Arrêter le scan',
    pauseScan: 'Mettre en pause',
    resumeScan: 'Reprendre',
    deleteScan: 'Supprimer le scan',
    scanDetails: 'Détails du scan',
    scanResults: 'Résultats du scan',
    progress: 'Progression',
    duration: 'Durée',
    startedAt: 'Démarré le',
    completedAt: 'Terminé le',
    status: {
      waiting: 'En file d\'attente',
      queued: 'En file d\'attente',
      pending: 'En attente',
      running: 'En cours',
      completed: 'Terminé',
      failed: 'Échoué',
      cancelled: 'Annulé',
      paused: 'En pause',
      stopped: 'Arrêté',
      scheduled: 'Planifié'
    },
    filters: {
      all: 'Tous',
      failed: 'Échecs'
    },
    types: {
      quick: 'Scan rapide',
      full: 'Scan complet',
      stealth: 'Scan furtif',
      aggressive: 'Scan agressif',
      custom: 'Scan personnalisé',
      ai_scan: 'Scan IA',
      iot_scan: 'Scan IoT',
      ot_scan: 'Scan OT/ICS',
      cloud_scan: 'Scan Cloud',
      full_autonomous: 'Autonome complet',
      full_auto: 'Autonome complet',
      full_automation: 'Autonome complet',
      network_discovery: 'Découverte réseau',
      vulnerability_scan: 'Scan de vulnérabilités',
      expert: 'Scan expert',
      api_pentest: 'Scan API',
      ad_pentest: 'Pentest Active Directory',
      ad_scan: 'Scan Active Directory',
      wifi_pentest: 'Pentest Wi-Fi',
      social_engineering: 'Ingénierie sociale',
      red_team: 'Red Team',
      phishing: 'Campagne de phishing'
    },
    phases: {
      discovery: 'Découverte',
      portScan: 'Scan de ports',
      serviceDetection: 'Détection de services',
      vulnScan: 'Scan de vulnérabilités',
      exploitation: 'Exploitation',
      reporting: 'Rapport'
    },
    stealthMode: {
      title: 'Mode Furtif',
      description: 'Techniques d\'évasion IDS/IPS',
      none: 'Aucun',
      noneDesc: 'Scan rapide, détectable',
      basic: 'Basique',
      basicDesc: 'Paquets fragmentés',
      advanced: 'Avancé',
      advancedDesc: 'Timing lent + spoofing',
      paranoid: 'Paranoïaque',
      paranoidDesc: 'Évasion max (très lent)',
      warning: 'Les modes furtifs utilisent des techniques d\'évasion pour éviter la détection IDS/IPS',
      basicTime: 'Le scan prendra environ 2x plus de temps',
      advancedTime: 'Le scan prendra environ 5x plus de temps',
      paranoidTime: 'Le scan prendra environ 10x plus de temps'
    },
    advancedDiscoveryOptions: 'Options de découverte avancées',
    hosts: 'Hôtes',
    ports: 'Ports',
    services: 'Services',
    openPorts: 'Ports ouverts',
    closedPorts: 'Ports fermés',
    filteredPorts: 'Ports filtrés',
    noResults: 'Aucun résultat trouvé',
    exportResults: 'Exporter les résultats',
    configureScan: 'Configurer les paramètres détaillés du scan',
    steps: {
      targetType: 'Cible & Type',
      networkMode: 'Mode Réseau',
      scanOptions: 'Options',
      advanced: 'Avancée',
      review: 'Vérification'
    },
    allScans: 'Total',
    activeScans: 'Scans actifs',
    withSuccess: 'Terminés avec succès',
    vulnerabilities: 'Vulnérabilités',
    discovered: 'Hôtes détectés',
    toReview: 'À vérifier',
    // Sort options
    sortByDate: 'Trier par date',
    sortByStatus: 'Trier par statut',
    sortByVulns: 'Trier par vuln.',
    // Stat card tooltips
    tooltips: {
      totalScans: 'Total des Scans',
      totalScansDesc: 'Nombre total de scans lancés sur la plateforme. Inclut tous les scans : en cours, terminés, et en échec.',
      runningScans: 'Scans en Cours',
      runningScansDesc: 'Scans actuellement en exécution. Ils analysent les cibles pour détecter les ports ouverts, services et vulnérabilités.',
      completedScans: 'Scans Terminés',
      completedScansDesc: 'Scans qui se sont terminés avec succès. Les résultats sont disponibles pour consultation et export dans les rapports.',
      vulnerabilities: 'Vulnérabilités Détectées',
      vulnerabilitiesDesc: 'Total des failles de sécurité identifiées. Les badges indiquent le nombre de vulnérabilités critiques et élevées nécessitant une attention immédiate.',
      hostsDiscovered: 'Hôtes Découverts',
      hostsDiscoveredDesc: 'Nombre de machines (serveurs, postes, équipements réseau) détectées lors des scans. Chaque hôte peut avoir plusieurs ports et services exposés.',
      failedScans: 'Scans Échoués',
      failedScansDesc: 'Scans échoués (cible inaccessible, timeout, problème réseau). Consultez les détails pour comprendre la cause et relancer si nécessaire.'
    },
    notFound: 'Scan non trouvé',
    notFoundDesc: 'Le scan demandé n\'existe pas ou a été supprimé',
    backToScans: 'Retour aux scans',
    scanFailed: 'Scan échoué',
    genericError: 'Une erreur s\'est produite pendant l\'exécution du scan. Cela peut être dû à des problèmes de connectivité réseau, des cibles inaccessibles ou des ressources insuffisantes.',
    technicalDetails: 'Détails techniques',
    retryScan: 'Relancer ce scan',
    // Console labels
    consoleLive: 'Console en direct',
    consoleCompleted: 'Console (Terminé)',
    consoleFailed: 'Console (Échec)',
    consoleTitle: 'Console',
    scanCompletedMessage: '✓ Terminé !',
    scanFailedMessage: '✗ Échec du scan',
    // Progress steps
    stepCompleted: 'Terminé',
    stepWaiting: 'En attente',
    stepInProgress: 'Scan en cours',
    // Timestamp labels
    timestampStarted: 'Démarré',
    timestampCompleted: 'Terminé',
    // Cleanup mode
    cleanup: 'Nettoyage',
    cleanupTitle: 'Nettoyage post-pentest',
    cleanupDescription: 'Cette action va supprimer toutes les traces laissées par le pentest, incluant\u202F:',
    cleanupSessions: 'Sessions d\'exploitation actives',
    cleanupPersistence: 'Mécanismes de persistence installés',
    cleanupFiles: 'Fichiers temporaires et preuves',
    cleanupLogs: 'Logs d\'exécution APT',
    cleanupPreview: 'Aperçu du nettoyage',
    sessionsCount: 'Sessions',
    withPersistence: 'Avec persistence',
    aptExecutions: 'Exécutions APT',
    evidenceFiles: 'Fichiers évidence',
    evidenceSize: 'Taille évidence',
    cleanNow: 'Nettoyer maintenant',
    archiveAndClean: 'Archiver puis nettoyer',
    cleaning: 'Nettoyage...',
    cleanupSuccess: 'Nettoyage terminé avec succès',
    cleanupPartial: 'Nettoyage partiel (certaines erreurs)',
    cleanupFailed: 'Échec du nettoyage',
    sessionsClosed: 'Sessions fermées',
    persistenceRemoved: 'Persistence supprimée',
    filesCleaned: 'Fichiers nettoyés',
    aptLogsCleaned: 'Logs APT nettoyés',
    evidenceArchived: 'Evidence archivée',
    cleanupWarning: '⚠️ Cette action est irréversible. Assurez-vous d\'avoir sauvegardé les données importantes.',
    // AI Quota
    aiQuotaExceeded: 'Quota de scans IA atteint',
    aiScansUsed: 'Scans IA utilises',
    upgradeOptions: 'Options pour continuer',
    callSylink: 'Appelez le service client SYLink\u202F:',
    upgradePlan: 'Passez à un abonnement supérieur pour des scans IA illimités',
    viewPlans: 'Voir les abonnements',
    // Scan types for NewScan wizard
    networkDiscovery: 'Découverte Réseau',
    networkDiscoveryDesc: 'Découverte rapide des hôtes et ports',
    vulnerabilityScan: 'Scan de Vulnérabilités',
    vulnerabilityScanDesc: 'Analyse approfondie des vulnérabilités',
    fullAutonomous: 'Autonome complet',
    fullAutonomousDesc: 'Évaluation de sécurité complète',
    // Placeholders
    placeholders: {
      target: '192.168.1.0/24 ou exemple.com',
      targetExamples: 'Exemples : 192.168.1.1, 192.168.1.0/24, exemple.com, 10.0.0.0/8',
      customPorts: 'Ex. : 80,443,8080-8090',
      excludeHosts: 'Ex. : 192.168.1.1,192.168.1.5'
    },
    searchPlaceholder: 'Rechercher par Cible ou Type...',
    // Table column headers
    table: {
      name: 'Nom',
      score: 'Score',
      target: 'Cible',
      client: 'Client',
      type: 'Type',
      status: 'Statut',
      vulnerabilities: 'Vuln.',
      date: 'Date',
      actions: 'Actions'
    }
  },

  // Workspaces
  workspaces: {
    title: 'Espaces clients',
    subtitle: 'Gérez vos espaces clients et leurs configurations',
    newWorkspace: 'Nouvel espace',
    editWorkspace: 'Modifier l\'espace',
    deleteWorkspace: 'Supprimer l\'espace',
    deleteWorkspaceError: 'Erreur lors de la suppression de l\'espace',
    deleteWorkspaceSuccess: 'Espace supprimé avec succès',
    invalidIdentifier: 'Veuillez entrer un identifiant valide',
    workspaceDetails: 'Détails de l\'espace',
    workspaceName: 'Nom de l\'espace',
    clientName: 'Nom du client',
    clientInfo: 'Informations client',
    companyName: 'Nom de l\'entreprise',
    searchCompany: 'Rechercher une entreprise',
    postalCode: 'Code postal',
    nafCode: 'Code NAF',
    capital: 'Capital',
    employees: 'Effectif',
    companyLogo: 'Logo de l\'entreprise',
    noLogo: 'Aucun logo',
    vpnConfiguration: 'Configuration VPN',
    contractStatus: 'Statut du contrat',
    sendContract: 'Envoyer le contrat',
    readyForTests: 'Prêt pour les tests',
    upload: 'Téléverser',
    members: 'Membres',
    addMember: 'Ajouter un membre',
    removeMember: 'Retirer le membre',
    scansCount: 'Nombre de scans',
    lastActivity: 'Dernière activité',
    created: 'Créé le',
    shareWorkspace: 'Partager l\'espace',
    archiveWorkspace: 'Archiver l\'espace',
    noWorkspaces: 'Aucun espace client',
    // Form labels
    siret: 'SIRET',
    siretPlaceholder: 'Ex : 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'Ex : 123 456 789',
    country: 'Pays',
    // Additional workspace keys
    scans: 'Scans',
    hosts: 'Hôtes',
    vulnerabilities: 'Vulnérabilités',
    attackPaths: 'Chemins d\'attaque',
    successfulScans: 'Scans réussis',
    company: 'Entreprise',
    legalForm: 'Forme juridique',
    address: 'Adresse',
    city: 'Ville',
    website: 'Site web',
    shareDescription: 'Partagez cet espace avec vos clients ou collaborateurs',
    manageShares: 'Gérer les partages',
    mainContact: 'Contact principal',
    contact: 'Contact',
    signed: 'Signé',
    pending: 'En attente',
    draft: 'Brouillon',
    contractSigned: 'Contrat signé',
    contractNotSigned: 'Contrat non signé',
    pendingContract: 'Contrat en attente',
    noContract: 'Aucun contrat',
    noScans: 'Aucun scan associé',
    noScansHint: 'Associez un scan existant ou lancez-en un nouveau depuis la page Scans',
    noHosts: 'Aucun hôte',
    noVulnerabilities: 'Aucune vulnérabilité',
    noAttackPaths: 'Aucun chemin d\'attaque',
    // Network stats
    vulnerable: 'Vulnérables',
    subnets: 'Sous-réseaux',
    services: 'Services',
    // Contact form labels
    contactFullName: 'Nom complet',
    contactFunction: 'Fonction',
    contactEmail: 'E-mail',
    contactPhone: 'Téléphone',
    contactResponsibleDescription: 'Personne responsable du projet pentest',
    logoUsedInReports: 'Utilisé dans les rapports de pentest',
    noAttackTree: 'Aucun arbre d\'attaque',
    noVPN: 'Aucun VPN configuré',
    // AI Analysis
    aiAnalysis: 'Analyse IA',
    generateSummary: 'Générer le résumé',
    launchAiAnalysis: 'Lancer l\'analyse IA',
    analysisInProgress: 'Analyse en cours...',
    completeAnalysis: 'Analyse complète & Solutions',
    aggregatedData: 'Données agrégées',
    riskAnalysis: 'Analyse des risques',
    clickToGenerateSummary: 'Cliquez sur "Générer le résumé" pour obtenir une analyse IA de l\'espace de travail',
    analyzingInProgress: 'Analyse en cours...',
    generatingAiSummary: 'Génération du résumé IA',
    noScansToAssociate: 'Aucun scan disponible à associer',
    associateScan: 'Associer un scan',
    networkMap: 'Carte Réseau',
    noAnalysisAvailable: 'Aucune analyse disponible',
    clickToLaunchAnalysis: 'Cliquez sur le bouton ci-dessus pour lancer l\'analyse IA',
    launchScanToDiscoverNetwork: 'Lancez un scan pour découvrir le réseau',
    critical: 'Critiques',
    high: 'Hautes',
    download: 'Télécharger',
    deleteStoredCredentials: 'Supprimer les identifiants enregistrés',
    useStoredCredentials: 'utiliser identifiants enregistrés',
    enterVpnUsername: 'Entrez votre identifiant VPN',
    enterVpnPassword: 'Entrez votre mot de passe VPN',
    // VPN Modal
    actionPlan: 'Plan d\'action & Solutions',
    noDocuments: 'Aucun document généré pour cet espace de travail',
    reportsWillAppear: 'Les rapports apparaîtront ici après génération',
    vpnCredentials: 'Identifiants VPN',
    requiresAuthentication: 'nécessite une authentification',
    storedCredentials: 'Identifiants enregistrés',
    clickToUseCredentials: 'Cliquez sur "Se connecter" pour utiliser ces identifiants',
    connect: 'Se connecter',
    cancel: 'Annuler',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    saveCredentials: 'Enregistrer ces identifiants',
    saveCredentialsSecurely: 'Enregistrer les identifiants de façon sécurisée',
    credentialsStorageInfo: 'Les identifiants seront chiffrés (AES-256) et stockés en base de données. Ils seront automatiquement utilisés lors des prochaines connexions VPN.',
    saving: 'Enregistrement...',
    connecting: 'Connexion...',
    server: 'Serveur',
    protocol: 'Protocole',
    noVulnsToFix: 'Aucune vulnérabilité à corriger',
    connectionInProgress: 'Connexion en cours...',
    connectionFailed: 'Connexion échouée',
    generateActionPlan: 'Générer le plan d\'action',
    clickToGenerateActionPlan: 'Cliquez sur "Générer le plan d\'action" pour obtenir les recommandations',
    vpnConnected: 'VPN connecté\u202F! IP\u202F:',
    // Workspace Switcher
    select: 'Sélectionnez un espace de travail',
    selectTitle: 'Sélection de l\'espace de travail',
    selectDescription: 'Choisissez un espace de travail pour continuer',
    searchPlaceholder: 'Rechercher un espace de travail...',
    noWorkspacesYet: 'Aucun espace de travail créé',
    noResults: 'Aucun espace de travail trouvé',
    createFirst: 'Créer votre premier espace de travail',
    createNew: 'Créer un espace de travail',
    manageAll: 'Gérer les espaces de travail',
    continue: 'Continuer',
    switchError: 'Erreur lors du changement d\'espace de travail',
    switchSuccess: 'Espace de travail changé avec succès',
    // Schedules
    scanSchedules: 'Planifications de scan',
    addSchedule: 'Ajouter une planification',
    noSchedules: 'Aucune planification configurée',
    noSchedulesHint: 'Cliquez sur "Ajouter une planification" pour automatiser vos scans',
    createSchedule: 'Créer une planification',
    scheduleName: 'Nom de la planification',
    scheduleNamePlaceholder: 'Ex: Scan hebdomadaire de sécurité',
    targets: 'Cibles',
    targetsPlaceholder: '192.168.1.0/24, exemple.com',
    targetsCommaSeparated: 'Cibles * (séparées par des virgules)',
    scanType: 'Type de scan',
    frequency: 'Fréquence',
    timeOfDay: 'Heure d\'exécution',
    daysOfWeek: 'Jours de la semaine',
    autoGenerateReport: 'Générer le rapport automatiquement',
    sendNotifications: 'Envoyer des notifications',
    notificationRecipients: 'Destinataires des notifications (e-mails, séparés par des virgules)',
    cancel: 'Annuler',
    creating: 'Création...',
    // Scan types
    scanTypeQuick: 'Rapide',
    scanTypeFull: 'Complet',
    scanTypeVulnerability: 'Vulnérabilités',
    scanTypePortScan: 'Scan de ports',
    scanTypeWebScan: 'Scan Web',
    // Frequencies
    frequencyDaily: 'Quotidien',
    frequencyWeekly: 'Hebdomadaire',
    frequencyBiweekly: 'Bimensuel',
    frequencyMonthly: 'Mensuel',
    frequencyQuarterly: 'Trimestriel',
    // Days
    dayMon: 'Lun',
    dayTue: 'Mar',
    dayWed: 'Mer',
    dayThu: 'Jeu',
    dayFri: 'Ven',
    daySat: 'Sam',
    daySun: 'Dim',
    // Stats labels
    schedulesCount: 'Planifications',
    successfulRuns: 'Exécutions réussies',
    runNow: 'Exécuter maintenant',
    nextRun: 'Prochain'
  },

  // Workspace (alias for workspace switcher)
  workspace: {
    select: 'Sélectionnez un espace de travail',
    selectTitle: 'Sélection de l\'espace de travail',
    selectDescription: 'Choisissez un espace de travail pour continuer',
    searchPlaceholder: 'Rechercher un espace de travail...',
    noWorkspaces: 'Aucun espace de travail disponible',
    noWorkspacesYet: 'Aucun espace de travail créé',
    noResults: 'Aucun espace de travail trouvé',
    createFirst: 'Créer votre premier espace de travail',
    createNew: 'Créer un espace de travail',
    manageAll: 'Gérer les espaces de travail',
    continue: 'Continuer',
    switchError: 'Erreur lors du changement d\'espace de travail',
    switchSuccess: 'Espace de travail changé avec succès',
    scan: 'scan',
    scans: 'scans',
    createRequired: 'Espace de travail requis',
    createRequiredDescription: 'Vous devez créer un espace de travail pour accéder à cette section.',
    selectRequired: 'Sélection requise',
    selectRequiredDescription: 'Veuillez sélectionner un espace de travail pour accéder à cette section. Vous avez',
    workspacesAvailable: 'espace(s) de travail disponible(s).',
    selectWorkspace: 'Sélectionnez un espace de travail'
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnérabilités',
    subtitle: 'Analyse et gestion des vulnérabilités détectées',
    aiAssistant: 'Assistant IA',
    aiAssistantDesc: 'Analysez et exploitez les vulnérabilités de manière autonome',
    vulnerability: 'Vulnérabilité',
    severity: 'Sévérité',
    severities: {
      critical: 'Critique',
      high: 'Haute',
      medium: 'Moyenne',
      low: 'Basse',
      info: 'Informatif'
    },
    cve: 'CVE',
    cvss: 'Score CVSS',
    affected: 'Affecté',
    solution: 'Solution',
    references: 'Références',
    evidence: 'Preuves',
    exploitable: 'Exploitable',
    verified: 'Vérifié',
    falsePositive: 'Faux positif',
    validation: {
      confirmed: 'Confirmé exploitable',
      theoretical: 'Théorique',
      not_exploitable: 'Non exploitable',
      unvalidated: 'Non validé',
      poc_title: 'Preuve de Concept',
      narrative: 'Narratif d\'exploitation',
      exploit_path: 'Chemin d\'exploitation',
      prerequisites: 'Prérequis',
    },
    markAsFixed: 'Marquer comme corrigé',
    noVulnerabilities: 'Aucune vulnérabilité trouvée',
    export: 'Exporter les vulnérabilités',
    distributionBySeverity: 'Répartition par Sévérité',
    priority: {
      auto: 'Automatique',
    },
    searchPlaceholder: 'Rechercher par titre, CVE, description...',
    noVulnerabilitiesFound: 'Aucune vulnérabilité n\'a été trouvée dans les scans.',
    noVulnerabilitiesBySeverity: 'Aucune vulnérabilité de sévérité {severity} trouvée.',
    customActionPlaceholder: 'Ex : shell_inverse, extraction_creds, porte_derobee...',
    // Action Panel
    actionPanel: {
      title: 'Actions sur la vulnérabilité',
    },
    // Attack Chain
    attackChain: {
      title: 'Classement des Chaînes d\'Attaque',
      analysisTitle: 'Analyse des Risques',
      subtitle: 'Analyse des risques multi-vulnérabilités pour pénétrer la cible',
      riskScore: 'Score de risque',
      vulnCount: 'vulnérabilités',
      attackPath: 'Chemin d\'attaque vers l\'objectif',
      // Chart
      chartTitle: 'Distribution des Vulnérabilités',
      chartSubtitle: 'Analyse statistique des CVE détectées',
      bySeverity: 'Répartition par Sévérité',
      keyMetrics: 'Métriques Clés',
      totalVulns: 'Total CVE',
      avgCvss: 'CVSS Moyen',
      criticalHigh: 'Critique + Haute',
      affectedHosts: 'Hôtes Affectés',
      topCves: 'Top CVE par CVSS',
      // Stages
      stages: {
        initialAccess: 'Accès Initial',
        privEscalation: 'Élévation de Privilèges',
        persistence: 'Persistance',
        objective: 'Objectif'
      },
      exploitVia: 'Exploitation via',
      escalationVia: 'Escalade via',
      maintenanceVia: 'Maintien via',
      fullCompromise: 'Compromission complète du système',
      adminAccess: 'Accès administrateur possible',
      initialSystemAccess: 'Accès initial au système',
      // Risk Factors
      riskFactors: 'Facteurs de risque',
      factors: {
        multiVuln: 'Multi-vulnérabilités',
        multiVuln5: '{count} vulns combinables',
        multiVuln3: '{count} vulns sur cet hôte',
        criticalHighCombo: 'Combo Critical + High',
        rce: 'RCE potentiel',
        authBypass: 'Bypass auth possible',
        privEsc: 'Escalade privilèges',
        exposed: 'Services exposés',
        highCvss: 'CVSS moyen {score}'
      },
      // Ratings
      ratingCritical: 'CRITIQUE',
      ratingHigh: 'ÉLEVÉ',
      ratingMedium: 'MOYEN',
      ratingLow: 'FAIBLE',
      ratingSafe: 'SÉCURISÉ',
      // Details
      criticalPath: 'CHEMIN CRITIQUE',
      vulnsInChain: 'Vulnérabilités dans cette chaîne',
      noChains: 'Aucune chaîne d\'attaque détectée',
      noVulnsDesc: 'Aucune vulnérabilité n\'a été trouvée pour analyser les chemins d\'attaque.',
      viewDetails: 'Voir les détails',
      multiVulnWarning: 'Risque accru : plusieurs vulnérabilités exploitables en chaîne',
      // Recommendations
      recommendation: 'Recommandation d\'exploitation',
      recoCritical: 'Cette cible présente un risque critique. La combinaison de {count} vulnérabilités permet une compromission complète du système. Priorité maximale pour la remédiation.',
      recoHigh: 'Risque élevé de compromission. Les vulnérabilités combinées offrent un chemin d\'attaque viable. Action corrective recommandée dans les plus brefs délais.',
      recoMedium: 'Risque modéré. Certaines vulnérabilités pourraient être chaînées pour une exploitation. À surveiller et corriger selon la priorité.',
      recoLow: 'Risque faible. Les vulnérabilités présentes ont un impact limité et sont difficiles à exploiter en chaîne.',
      // Stats
      criticalPaths: 'Chemins Critiques',
      highRisk: 'Risque Élevé',
      multiVuln: 'Multi-Vulns (3+)',
      hostsAnalyzed: 'Hôtes Analysés',
      avgScore: 'Score Moyen',
      // Info
      infoText: 'Ce classement identifie les hôtes les plus vulnérables en analysant les combinaisons de vulnérabilités exploitables pour atteindre l\'objectif de pénétration.',
      // Legend
      legendCritical: 'Critique (80-100)',
      legendHigh: 'Élevé (60-79)',
      legendMedium: 'Moyen (40-59)',
      legendLow: 'Faible (20-39)',
      legendSafe: 'Sécurisé (0-19)'
    }
  },

  // Reports
  reports: {
    title: 'Rapports',
    newReport: 'Nouveau rapport',
    generateReport: 'Générer un rapport',
    downloadReport: 'Télécharger le rapport',
    reportType: 'Types de rapports',
    settings: 'Paramètres',
    branding: 'Image de marque',
    types: {
      executive: 'Rapport exécutif',
      technical: 'Rapport technique',
      compliance: 'Rapport de conformité',
      full: 'Rapport complet',
      vulnerability_list: 'Rapport de vulnérabilités',
      redteam: 'Rapport équipe rouge',
      retest: 'Rapport de contre-test',
      multi_campaign: 'Rapport multi-campagnes',
      active_directory: 'Rapport Active Directory',
      data_leak: 'Rapport de fuites de données',
      attack_surface: 'Rapport de surface d\'attaque'
    },
    typeDescriptions: {
      executive: 'Synthèse stratégique pour le COMEX avec indicateurs clés et recommandations prioritaires',
      technical: 'Analyse complète des vulnérabilités avec détails techniques et remédiations',
      vulnerability_list: 'Export structuré pour Jira, ServiceNow, GLPI',
      redteam: 'Scénario d\'attaque narratif avec MITRE ATT&CK mapping',
      retest: 'Comparaison avant/après correction',
      multi_campaign: 'Vue consolidée de plusieurs scans',
      active_directory: 'Audit AD, privilèges, GPO, délégations',
      data_leak: 'Détection des données exposées et credentials',
      attack_surface: 'Cartographie de l\'exposition externe'
    },
    format: 'Format',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Texte (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Inclure les preuves',
    includeRemediation: 'Inclure les recommandations',
    generatedAt: 'Généré le',
    generatedBy: 'Généré par',
    noReports: 'Aucun rapport',
    // AI Generated Reports
    aiGenerated: 'Rapports IA',
    generated: {
      title: 'Rapports Générés par IA',
      subtitle: 'Rapports professionnels générés par LLM',
      create: 'Créer un rapport',
      createNew: 'Nouveau rapport IA',
      selectType: 'Type de rapport',
      selectScan: 'Sélectionner un scan',
      selectWorkspace: 'Sélectionnez un espace de travail',
      selectFormat: 'Format de sortie',
      generating: 'Génération en cours...',
      regenerate: 'Régénérer',
      regenerateSection: 'Régénérer cette section',
      export: 'Exporter',
      download: 'Télécharger',
      delete: 'Supprimer',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce rapport\u202F?',
      status: {
        pending: 'En attente',
        queued: 'En file d\'attente',
        generating: 'En génération',
        completed: 'Terminé',
        failed: 'Échec',
        cancelled: 'Annulé'
      },
      sections: {
        executive_summary: 'Résumé exécutif',
        key_findings: 'Conclusions principales',
        recommendations: 'Recommandations',
        technical_details: 'Détails techniques',
        vulnerability_analysis: 'Analyse des vulnérabilités',
        risk_assessment: 'Évaluation des risques',
        remediation_plan: 'Plan de remédiation',
        attack_narrative: 'Récit d\'attaque',
        mitre_mapping: 'Mapping MITRE ATT&CK',
        timeline: 'Chronologie',
        appendix: 'Annexes'
      },
      quality: {
        score: 'Score de qualité',
        excellent: 'Excellent',
        good: 'Bon',
        average: 'Moyen',
        poor: 'Faible'
      },
      noReports: 'Aucun rapport généré',
      noReportsDesc: 'Créez votre premier rapport IA pour commencer',
      totalReports: 'Total des rapports',
      completedReports: 'Rapports terminés',
      averageQuality: 'Qualité moyenne',
      lastGenerated: 'Dernier rapport'
    },
    // Export modal
    export: {
      title: 'Exportation',
      processing: 'Exportation en cours...',
      generating: 'Génération du fichier',
      takingLong: 'Cette opération prend plus de temps que prévu.',
      canWaitOrEmail: 'Vous pouvez patienter, ou fermer cette fenêtre et nous vous enverrons un lien par e-mail.',
      sendByEmail: 'Recevoir par e-mail',
      continueWaiting: 'Vous pouvez aussi continuer à attendre, le téléchargement démarrera automatiquement.',
      emailSent: 'E-mail envoyé !',
      emailSentDesc: 'Vous recevrez le lien de téléchargement par e-mail dans quelques instants.',
      wordLocked: 'Disponible pour les plans Entreprise et supérieurs'
    },
    // Report configuration placeholders
    placeholders: {
      footerText: 'Ex. : Document confidentiel - Ne pas diffuser',
      logoUrl: 'https://entreprise.fr/logo.png',
      contactEmail: 'contact@entreprise.fr',
      sectionTitle: 'Titre de la section...',
      sectionDescription: 'Description (optionnel)...',
      contentTemplate: 'Entrez le modèle de contenu (Markdown pris en charge)...\n\nVariables disponibles :\n{{scan.target}} - Cible du scan\n{{scan.date}} - Date du scan\n{{vulnerabilities.count}} - Nombre de vulnérabilités\n{{vulnerabilities.critical}} - Vulnérabilités critiques'
    },
    // Report configuration labels
    config: {
      title: 'Configuration',
      subtitle: 'Configurez les types de rapports disponibles et personnalisez leur contenu',
      settingsTitle: 'Paramètres des rapports',
      brandingTitle: 'Image de marque des rapports',
      defaultLanguage: 'Langue par défaut',
      confidentialityLevel: 'Niveau de confidentialité',
      includeOptions: 'Options d\'inclusion',
      includeLogo: 'Inclure le logo',
      includeTableOfContents: 'Inclure la table des matières',
      includeAppendices: 'Inclure les annexes',
      includeMethodology: 'Inclure la méthodologie',
      footerTextLabel: 'Texte de pied de page',
      logoUrlLabel: 'URL du logo',
      primaryColor: 'Couleur principale',
      secondaryColor: 'Couleur secondaire',
      companyInfo: 'Informations société (pour les rapports)',
      companyName: 'Nom de la société',
      address: 'Adresse',
      contactEmail: 'E-mail de contact',
      phone: 'Téléphone',
      website: 'Site web',
      sectionsTitle: 'Sections du rapport',
      addSection: 'Ajouter une section',
      noTypeSelected: 'Aucun type sélectionné',
      noTypeSelectedHint: 'Cliquez sur un type de rapport dans la liste pour afficher et personnaliser ses sections',
      sectionRequired: 'Section requise',
      sectionActive: 'Actif',
      requiredBadge: 'Requis',
      contentTemplateLabel: 'Modèle de contenu (Markdown pris en charge)',
      clickToAddTemplate: 'Cliquez pour ajouter un modèle de contenu...',
      markdownHint: 'Utilisez Markdown pour le formatage. Variables : {{variable}}',
      noReportTypes: 'Aucun type de rapport disponible'
    }
  },

  // Account
  account: {
    title: 'Mon compte',
    profile: 'Profil',
    security: 'Sécurité',
    subscription: 'Abonnement',
    billing: 'Facturation',
    credits: 'Crédits',
    notifications: 'Notifications',
    integrations: 'Intégrations',
    referral: 'Parrainage',
    activity: 'Activité',
    contracts: 'Contrats',

    // Profile section
    profileSection: {
      title: 'Informations du profil',
      avatar: 'Photo de profil',
      changeAvatar: 'Changer la photo',
      removeAvatar: 'Supprimer la photo',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      company: 'Entreprise',
      position: 'Fonction',
      timezone: 'Fuseau horaire',
      language: 'Langue du portail',
      languageDescription: 'Choisissez la langue d\'affichage de l\'interface',
      updateSuccess: 'Profil mis à jour avec succès',
      updateError: 'Erreur lors de la mise à jour du profil',
      // Language names in French
      languages: {
        fr: 'Français',
        en: 'Anglais',
        es: 'Espagnol',
        de: 'Allemand',
        it: 'Italien',
        pt: 'Portugais'
      }
    },

    // Security section
    securitySection: {
      title: 'Sécurité du compte',
      changePassword: 'Changer le mot de passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      passwordRequirements: 'Le mot de passe doit contenir au moins 8 caractères',
      twoFactorAuth: 'Authentification à deux facteurs',
      enable2FA: 'Activer la 2FA',
      disable2FA: 'Désactiver la 2FA',
      twoFactorEnabled: '2FA activée',
      twoFactorDisabled: '2FA désactivée',
      activeSessions: 'Sessions actives',
      revokeSession: 'Révoquer la session',
      revokeAllSessions: 'Révoquer toutes les sessions',
      loginHistory: 'Historique des connexions',
      lastLogin: 'Dernière connexion',
      apiKeys: 'Clés API',
      generateApiKey: 'Générer une clé API',
      deleteApiKey: 'Supprimer la clé API'
    },

    // Subscription section
    subscriptionSection: {
      title: 'Abonnement',
      currentPlan: 'Plan actuel',
      planDetails: 'Détails du plan',
      features: 'Fonctionnalités incluses',
      usage: 'Utilisation',
      limits: 'Limites',
      renewalDate: 'Date de renouvellement',
      cancelSubscription: 'Annuler l\'abonnement',
      upgradePlan: 'Passer à un plan supérieur',
      downgradePlan: 'Passer à un plan inférieur',
      plans: {
        free: 'Gratuit',
        pro: 'Pro',
        enterprise: 'Entreprise',
        dedicated: 'Dédié'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Gestion des crédits',
      subtitle: 'Gérez vos crédits, abonnements et packs',
      balance: 'Solde',
      totalCredits: 'Crédits totaux',
      monthlyCredits: 'Crédits mensuels',
      packCredits: 'Crédits pack',
      usedThisMonth: 'Utilisés ce mois',
      remaining: 'Restants',
      buyCredits: 'Acheter des crédits',
      creditHistory: 'Historique des crédits',
      transaction: 'Transaction',
      amount: 'Montant',
      creditCosts: 'Coût des opérations',
      scanCost: 'Coût d\'un scan',
      reportCost: 'Coût d\'un rapport',
      // Additional keys for CreditsPage
      expires: 'Expire le',
      noExpiration: 'Sans expiration',
      currentPlan: 'Plan actuel',
      statusActive: 'Actif',
      monthlyPlans: 'Plans mensuels',
      free: 'Gratuit',
      perMonth: '/mois',
      creditsPerMonth: 'crédits/mois',
      unlimitedWorkspaces: 'Espaces clients illimités',
      externalScans: 'Scans externes',
      internalScans: 'Scans internes',
      adScans: 'Scans Active Directory',
      select: 'Sélectionner',
      creditPacks: 'Packs de crédits',
      credits: 'crédits',
      validity: 'Validité',
      months: 'mois',
      buy: 'Acheter',
      scans: 'Scans',
      leakDetection: 'Détection de fuites',
      audits: 'Audits',
      reports: 'Rapports',
      noTransactions: 'Aucune transaction',
      transactionHistory: 'Historique des transactions',
      refresh: 'Actualiser',
      date: 'Date',
      type: 'Type',
      dashboard: 'Tableau de bord',
      plansAndPacks: 'Plans & Packs',
      history: 'Historique',
      errorOccurred: 'Une erreur est survenue',
      creditsAvailable: 'crédits disponibles',
      confirmPlanChange: 'Confirmer le changement de plan',
      confirmPurchase: 'Confirmer l\'achat',
      planActiveImmediately: 'Le plan sera actif immédiatement',
      creditsAddedImmediately: 'Les crédits seront ajoutés immédiatement',
      cancel: 'Annuler',
      processing: 'Traitement...',
      confirm: 'Confirmer',
      planSubscribed: 'Abonnement au plan {plan} réussi',
      packPurchased: 'Achat du pack {pack} réussi',
      statusPremium: 'PREMIUM',
      statusExhausted: 'ÉPUISÉ',
      statusCritical: 'CRITIQUE',
      statusLow: 'FAIBLE',
      unlimited: 'Illimité'
    },

    // Notifications section
    notificationsSection: {
      title: 'Préférences de notification',
      emailNotifications: 'Notifications par e-mail',
      pushNotifications: 'Notifications push',
      scanCompleted: 'Scan terminé',
      scanFailed: 'Scan échoué',
      newVulnerability: 'Nouvelle vulnérabilité critique',
      reportReady: 'Rapport prêt',
      securityAlerts: 'Alertes de sécurité',
      weeklyDigest: 'Résumé hebdomadaire',
      marketingEmails: 'E-mails marketing'
    },

    // Integrations section
    integrationsSection: {
      title: 'Intégrations',
      connected: 'Connecté',
      notConnected: 'Non connecté',
      configure: 'Configurer',
      disconnect: 'Déconnecter',
      testConnection: 'Tester la connexion',
      connectionSuccess: 'Connexion réussie',
      connectionFailed: 'Échec de la connexion',
      availableIntegrations: 'Intégrations disponibles',
      myIntegrations: 'Mes intégrations'
    },

    // Referral section
    referralSection: {
      title: 'Programme de parrainage',
      referralLink: 'Lien de parrainage',
      copyLink: 'Copier le lien',
      shareLink: 'Partager le lien',
      inviteFriends: 'Inviter des amis',
      referralStats: 'Statistiques de parrainage',
      totalReferrals: 'Total des parrainages',
      pendingReferrals: 'Parrainages en attente',
      completedReferrals: 'Parrainages complétés',
      earnedCredits: 'Crédits gagnés',
      inviteByEmail: 'Inviter par e-mail',
      contacts: 'Contacts invités',
      rewards: 'Récompenses',
      leaderboard: 'Classement'
    }
  },

  // Settings
  settings: {
    title: 'Paramètres',
    general: 'Général',
    tools: 'Outils',
    network: 'Réseau',
    advanced: 'Avancé',

    // General settings
    generalSection: {
      title: 'Paramètres généraux',
      defaultScanType: 'Type de scan par défaut',
      defaultReportFormat: 'Format de rapport par défaut',
      autoSaveReports: 'Sauvegarde automatique des rapports',
      enableNotifications: 'Activer les notifications',
      darkMode: 'Mode sombre',
      compactView: 'Vue compacte'
    },

    // Tools settings
    toolsSection: {
      title: 'Configuration des outils',
      enabledTools: 'Outils activés',
      toolSettings: 'Paramètres des outils',
      timeout: 'Délai d\'attente',
      threads: 'Nombre de threads',
      verbosity: 'Niveau de verbosité'
    },

    // Network settings
    networkSection: {
      title: 'Configuration réseau',
      proxySettings: 'Paramètres proxy',
      vpnSettings: 'Paramètres VPN',
      dnsSettings: 'Paramètres DNS',
      useProxy: 'Utiliser un proxy',
      proxyHost: 'Hôte du proxy',
      proxyPort: 'Port du proxy'
    },

    // Server status
    uptime: 'Disponibilité'
  },

  // Admin
  admin: {
    title: 'Administration',
    users: 'Utilisateurs',
    companies: 'Entreprises',
    system: 'Système',
    logs: 'Journaux',
    maintenance: 'Maintenance',

    // Users management
    usersSection: {
      title: 'Gestion des utilisateurs',
      addUser: 'Ajouter un utilisateur',
      editUser: 'Modifier l\'utilisateur',
      deleteUser: 'Supprimer l\'utilisateur',
      activateUser: 'Activer l\'utilisateur',
      deactivateUser: 'Désactiver l\'utilisateur',
      resetPassword: 'Réinitialiser le mot de passe',
      role: 'Rôle',
      roles: {
        admin: 'Administrateur',
        user: 'Utilisateur',
        viewer: 'Observateur'
      },
      lastLogin: 'Dernière connexion',
      createdAt: 'Créé le',
      noUsers: 'Aucun utilisateur'
    },

    // System
    systemSection: {
      title: 'Système',
      systemInfo: 'Informations système',
      version: 'Version',
      uptime: 'Temps de fonctionnement',
      restart: 'Redémarrer',
      backup: 'Sauvegarder',
      restore: 'Restaurer',
      update: 'Mettre à jour'
    }
  },

  // Errors
  errors: {
    generic: 'Une erreur est survenue',
    notFound: 'Page non trouvée',
    // Backend error message translations (English to French mapping)
    backendMessages: {
      'Workspace not found': 'Espace de travail non trouvé',
      'Invalid signature token': 'Jeton de signature invalide',
      'Contract already signed': 'Contrat déjà signé',
      'Contract already pending signature. Cancel existing request first.': 'Contrat déjà en attente de signature. Annulez d\'abord la demande existante.',
      'Contract not yet signed': 'Contrat pas encore signé',
      'Signed contract file not found': 'Fichier du contrat signé non trouvé',
      'Contract file not found on disk': 'Fichier du contrat non trouvé sur le disque',
      'Contract already signed, cannot cancel': 'Contrat déjà signé, impossible d\'annuler',
      'No pending signature request to cancel': 'Aucune demande de signature en attente à annuler',
      'User not found': 'Utilisateur non trouvé',
      'Invalid credentials': 'Identifiants invalides',
      'Access denied': 'Accès refusé',
      'Permission denied': 'Permission refusée',
      'Not found': 'Non trouvé',
      'Bad request': 'Requête invalide',
      'Internal server error': 'Erreur interne du serveur',
      'Service unavailable': 'Service indisponible'
    },
    unauthorized: 'Accès non autorisé',
    forbidden: 'Accès interdit',
    serverError: 'Erreur serveur',
    networkError: 'Erreur réseau',
    timeout: 'Délai d\'attente dépassé',
    validation: 'Erreur de validation',
    invalidEmail: 'E-mail invalide',
    invalidPassword: 'Mot de passe invalide',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    requiredField: 'Ce champ est requis',
    minLength: 'Minimum {min} caractères requis',
    maxLength: 'Maximum {max} caractères autorisés',
    fillAllFields: 'Veuillez remplir tous les champs obligatoires',
    verificationFailed: 'La vérification de l\'e-mail a échoué. Le lien peut être expiré ou invalide.',
    invalidVerificationLink: 'Ce lien de vérification est invalide ou a expiré. Veuillez demander un nouveau lien.',
    rateLimitExceeded: 'Trop de tentatives. Veuillez réessayer dans quelques minutes.',
    rateLimitEmail: 'Veuillez patienter quelques minutes avant de renvoyer un e-mail de vérification.',
    emailAlreadyUsed: 'Cet e-mail est déjà utilisé',
    companyAlreadyRegistered: 'Cette entreprise est déjà enregistrée',
    registrationError: 'Erreur lors de l\'inscription',
    genericError: 'Une erreur inattendue s\'est produite',
    disposableEmailNotAllowed: 'Les e-mails temporaires ne sont pas autorisés',
    personalEmailNotAllowed: 'L\'e-mail {domain} n\'est pas autorisé. Utilisez un e-mail professionnel.',
    invalidResetLink: 'Ce lien de réinitialisation est invalide ou a expiré. Veuillez demander un nouveau lien.',
    resetLinkExpired: 'Ce lien de réinitialisation a expiré. Veuillez demander un nouveau lien.',
    resetPasswordFailed: 'Échec de la réinitialisation du mot de passe. Veuillez réessayer.',
    passwordCriteriaNotMet: 'Le mot de passe ne respecte pas tous les critères requis.',
    // Error page
    401: {
      title: 'Non Autorisé',
      subtitle: 'Oups ! Vous devez vous connecter',
      description: 'Votre session a expiré ou vous n\'êtes pas authentifié. Veuillez vous connecter pour accéder à cette page.',
      redirectText: 'Redirection vers la connexion'
    },
    403: {
      title: 'Accès Refusé',
      subtitle: 'Oups ! Accès interdit',
      description: 'Vous n\'avez pas les permissions nécessaires pour accéder à cette ressource.',
      redirectText: 'Redirection vers le dashboard'
    },
    404: {
      title: 'Page Non Trouvée',
      subtitle: 'Oups ! Page introuvable',
      description: 'La page que vous recherchez n\'existe pas ou a été déplacée.',
      redirectText: 'Redirection vers le dashboard'
    },
    500: {
      title: 'Erreur Serveur',
      subtitle: 'Oups ! Une erreur est survenue',
      description: 'Le serveur a rencontré une erreur. Veuillez réessayer dans quelques instants.',
      redirectText: 'Redirection vers le dashboard'
    },
    503: {
      title: 'Service Indisponible',
      subtitle: 'Oups ! Service temporairement indisponible',
      description: 'Le service est temporairement indisponible pour maintenance. Veuillez réessayer dans quelques instants.',
      redirectText: 'Redirection vers le dashboard'
    },
    backToDashboard: 'Retour au Dashboard',
    retry: 'Réessayer',
    supportContact: 'Si le problème persiste, contactez le support technique.',
    redirectingIn: 'dans',
    seconds: 'secondes'
  },

  // Success messages
  success: {
    saved: 'Enregistré avec succès',
    deleted: 'Supprimé avec succès',
    updated: 'Mis à jour avec succès',
    created: 'Créé avec succès',
    copied: 'Copié dans le presse-papiers',
    sent: 'Envoyé avec succès',
    uploaded: 'Téléversé avec succès'
  },

  // Time
  time: {
    now: 'Maintenant',
    seconds: 'secondes',
    minutes: 'minutes',
    hours: 'heures',
    days: 'jours',
    weeks: 'semaines',
    months: 'mois',
    years: 'ans',
    ago: 'il y a',
    in: 'dans'
  },

  // Credentials
  credentials: {
    title: 'Identifiants',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    hash: 'Hash',
    domain: 'Domaine',
    source: 'Source',
    foundAt: 'Trouvé le',
    noCredentials: 'Aucun identifiant trouvé',
    export: 'Exporter les identifiants'
  },

  // Sessions
  sessions: {
    title: 'Sessions',
    pageTitle: 'Sessions d\'Exploitation',
    pageDescription: 'Gestion des sessions d\'exploitation et accès compromis',
    sessionDetails: 'Détails de la session',
    activeSession: 'Session active',
    closedSession: 'Session fermée',
    sessionType: 'Type de session',
    target: 'Cible',
    startedAt: 'Démarré à',
    endedAt: 'Terminé à',
    duration: 'Durée',
    commands: 'Commandes',
    noSessions: 'Aucune session',
    closeSession: 'Fermer la session',
    interactiveShell: 'Terminal interactif',
    quickActions: 'Actions Rapides',
    quickCommands: 'Commandes Rapides',
    defaultSessionType: 'Terminal',
    sessionLabel: 'Session',
    manualExploit: 'Manuel',
    platform: 'Plateforme',
    platformUnknown: 'Inconnue',
    exploitUsed: 'Exploit utilisé',
    commandsExecuted: 'Commandes exécutées',
    status: {
      active: 'Active',
      inactive: 'Inactive',
      closed: 'Fermée',
      stale: 'À relancer',
      idle: 'Veille',
      error: 'Erreur',
      unknown: 'Inconnue',
      queued: 'En file d\'attente',
      running: 'En cours',
      pending: 'En attente',
      completed: 'Terminée',
      failed: 'Échouée'
    },
    badges: {
      root: 'ROOT',
      persistent: 'PERSISTANT'
    },
    persistence: {
      installed: 'Installée',
      notInstalled: 'Non installée'
    },
    quickPrompts: {
      help: 'Aide',
      privesc: 'Privesc',
      persistence: 'Persistence',
      lateral: 'Mouvement latéral',
      pocAuto: 'PoC auto',
      aptModules: 'Modules APT'
    },
    errors: {
      connectionError: 'Erreur de connexion au serveur',
      loadingError: 'Erreur lors du chargement des sessions',
      actionError: 'Erreur lors de l\'exécution de l\'action',
      serverError: 'Erreur serveur interne',
      serviceUnavailable: 'Service temporairement indisponible',
      loadFailed: 'Échec du chargement',
      screenshotFailed: 'Échec de la capture d\'écran',
      privescFailed: 'Échec de l\'escalade de privilèges',
      persistenceFailed: 'Échec de l\'installation de la persistance',
      aptExecutionFailed: 'Échec de l\'exécution du module APT'
    },
    actions: {
      screenshotSuccess: 'Capture d\'écran effectuée',
      privescSuccess: 'Escalade de privilèges réussie',
      privescCompleted: 'Tentative d\'escalade terminée',
      persistenceSuccess: 'Mécanisme de persistance installé',
      persistenceCompleted: 'Installation terminée'
    }
  },

  // Support
  support: {
    title: 'Support',
    myTickets: 'Mes Tickets Support',
    manageRequests: 'Gérez vos demandes d\'assistance',
    newTicket: 'Nouveau ticket',
    ticketDetails: 'Détails du ticket',
    subject: 'Sujet',
    message: 'Message',
    priority: 'Priorité',
    status: 'Statut',
    category: 'Catégorie',
    created: 'Créé',
    createdOn: 'Créé le',
    updated: 'Dernière mise à jour',
    resolved: 'Résolu',
    resolvedOn: 'Résolu le',
    noTickets: 'Aucun ticket',
    noTicketsFound: 'Aucun ticket trouvé',
    noTicketsYet: 'Vous n\'avez pas encore créé de ticket de support',
    tryModifyingSearch: 'Essayez de modifier vos critères de recherche',
    createFirstTicket: 'Créer mon premier ticket',
    sendMessage: 'Envoyer un message',
    send: 'Envoyer',
    sending: 'Envoi...',
    closeTicket: 'Fermer le ticket',
    closing: 'Fermeture...',
    ticketClosed: 'Ce ticket est fermé. Pour une nouvelle demande, créez un nouveau ticket.',
    search: 'Rechercher un ticket...',
    allStatuses: 'Tous les statuts',
    refresh: 'Actualiser',
    backToTickets: 'Retour aux tickets',
    ticketNumber: 'Numéro',
    you: 'Vous',
    supportTeam: 'Support SYLink',
    system: 'Système',
    writeReply: 'Écrivez votre réponse...',
    detailedDescription: 'Description détaillée',
    informations: 'Informations',
    needHelp: 'Besoin d\'aide\u202F?',
    responseTime: 'Temps de réponse estimé',
    responseTimeDesc: 'Notre équipe répond généralement sous 24h ouvrées. Les tickets urgents sont traités en priorité. Vous recevrez une notification par e-mail dès qu\'une réponse sera apportée.',
    supportResponseDesc: 'Notre équipe de support répond généralement sous 24h ouvrées. Pour les urgences, n\'hésitez pas à indiquer une priorité haute.',
    newTicketTitle: 'Nouveau Ticket',
    newTicketDesc: 'Décrivez votre problème et notre équipe vous répondra rapidement',
    describeIssue: 'Décrivez brièvement votre problème...',
    relatedWorkspace: 'Client / Espace de travail concerné (optionnel)',
    noSpecificWorkspace: 'Aucun espace de travail spécifique',
    detailedDescPlaceholder: 'Décrivez votre problème en détail. Plus vous donnez d\'informations, plus nous pourrons vous aider rapidement...\n\n- Qu\'essayez-vous de faire\u202F?\n- Qu\'est-ce qui se passe\u202F?\n- Qu\'attendiez-vous\u202F?\n- Avez-vous un message d\'erreur\u202F?',
    charactersCount: '{count} caractères',
    charactersMin: '{count} caractères (minimum {min})',
    cancel: 'Annuler',
    createTicket: 'Créer le ticket',
    creating: 'Création...',
    rateSupport: 'Comment évaluez-vous la qualité de notre support\u202F?',
    comment: 'Commentaire (optionnel)...',
    confirm: 'Confirmer',
    messages: 'message',
    messagesPlural: 'messages',
    resolutionNotes: 'Notes de résolution',
    yourRating: 'Votre évaluation',

    // Statuses
    statuses: {
      open: 'Ouvert',
      in_progress: 'En cours',
      waiting_customer: 'En attente de votre réponse',
      waiting_internal: 'En traitement',
      resolved: 'Résolu',
      closed: 'Fermé'
    },

    // Priorities
    priorities: {
      low: 'Basse',
      medium: 'Moyenne',
      high: 'Haute',
      urgent: 'Urgente',
      lowDesc: 'Pas urgent, peut attendre',
      mediumDesc: 'Importance normale',
      highDesc: 'Nécessite une attention rapide',
      urgentDesc: 'Impact critique sur l\'activité',
      priority: 'Priorité'
    },

    // Categories
    categories: {
      technical: 'Technique',
      billing: 'Facturation',
      feature_request: 'Demande de fonctionnalité',
      bug_report: 'Signalement de bug',
      account: 'Compte',
      security: 'Sécurité',
      other: 'Autre',
      technicalDesc: 'Problèmes techniques, erreurs, dysfonctionnements',
      billingDesc: 'Questions sur les factures, paiements, abonnements',
      feature_requestDesc: 'Suggestions d\'amélioration ou nouvelles fonctionnalités',
      bug_reportDesc: 'Signaler un bug ou comportement inattendu',
      accountDesc: 'Gestion du compte, accès, permissions',
      securityDesc: 'Questions ou préoccupations de sécurité',
      otherDesc: 'Autre type de demande'
    },

    // Errors
    errors: {
      loadingTickets: 'Erreur lors du chargement des tickets',
      loadingTicket: 'Erreur lors du chargement du ticket',
      sendingMessage: 'Erreur lors de l\'envoi du message',
      closingTicket: 'Erreur lors de la fermeture du ticket',
      creatingTicket: 'Erreur lors de la création du ticket',
      ticketNotFound: 'Ticket non trouvé',
      retry: 'Réessayer',
      fixFormErrors: 'Veuillez corriger les erreurs dans le formulaire',
      subjectRequired: 'Le sujet est requis',
      subjectMinLength: 'Le sujet doit contenir au moins 5 caractères',
      descriptionRequired: 'La description est requise',
      descriptionMinLength: 'La description doit contenir au moins 20 caractères'
    },

    // Success messages
    success: {
      ticketCreated: 'Ticket {number} créé avec succès',
      messageSent: 'Message envoyé',
      ticketClosed: 'Ticket fermé avec succès'
    }
  },

  // Attack
  attack: {
    title: 'Centre d\'Attaque',
    description: 'Outils d\'attaque avancés et orchestrateur dynamique',
    selectTarget: 'Sélectionner la cible',
    selectTechnique: 'Sélectionner la technique',
    launchAttack: 'Lancer l\'attaque',
    attackInProgress: 'Attaque en cours',
    attackCompleted: 'Attaque terminée',
    attackFailed: 'Attaque échouée',
    techniques: 'Techniques',
    payloads: 'Charges utiles',
    results: 'Résultats',
    dynamicOrchestrator: 'Orchestrateur Dynamique',
    attackGraph: 'Graphe d\'Attaque',
    attackBuilder: 'Constructeur d\'Attaque',
    launchChain: 'Lancer la chaîne',
    continueChain: 'Reprendre',
    restartAll: 'Relancer tout',
    executing: 'Exécution...',
    aiSuggestions: 'Suggestions IA',
    ready: 'Prêt',
    inProgress: 'En cours...'
  },

  // Pricing
  pricing: {
    title: 'Choisissez votre plan',
    subtitle: 'Des solutions de sécurité adaptées à toutes les tailles d\'entreprise. Commencez gratuitement et évoluez selon vos besoins.',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    yearlyDiscount: '-17%',
    perMonth: 'mois',
    perYear: 'an',
    ht: 'HT',
    or: 'Soit',
    perMonthShort: '/mois',
    onQuote: 'Sur devis',
    free: 'Gratuit',
    // Plan names and descriptions
    plans: {
      gratuit: {
        name: 'Gratuit',
        subtitle: 'Découverte',
        description: 'Idéal pour tester la plateforme',
        cta: 'Commencer gratuitement'
      },
      pro: {
        name: 'Pro',
        subtitle: 'Le plus populaire',
        description: 'Pour les professionnels et PME',
        cta: 'Choisir Pro',
        badge: 'Recommandé'
      },
      entreprise: {
        name: 'Entreprise',
        subtitle: 'Pour les grandes équipes',
        description: 'Fonctionnalités avancées et support dédié',
        cta: 'Choisir Entreprise'
      },
      entreprise_plus: {
        name: 'Groupe',
        subtitle: 'Pour les grandes organisations',
        description: 'Volume étendu et support premium',
        cta: 'Choisir Groupe'
      },
      sur_mesure: {
        name: 'Sur-Mesure',
        subtitle: 'Solution personnalisée',
        description: 'Adaptée à vos besoins spécifiques',
        cta: 'Nous contacter'
      }
    },
    // Features
    features: {
      simulationOnly: 'Mode simulation uniquement',
      oneUser: '1 utilisateur',
      oneTarget: '1 cible de test',
      basicDashboard: 'Dashboard basique',
      realScans: 'Scans réels',
      pdfReports: 'Rapports PDF',
      technicalSupport: 'Support technique',
      apiAccess: 'Accès API',
      unlimitedScans: 'Scans IA illimités',
      fiveUsers: '5 utilisateurs',
      tenTargets: '10 cibles',
      customPdfReports: 'Rapports PDF personnalisés',
      credentialSearch: 'Recherche de credentials',
      autoScheduling: 'Planification automatique',
      prioritySupport: 'Support prioritaire',
      allProFeatures: 'Tout le plan Pro +',
      fifteenUsers: '15 utilisateurs',
      thirtyTargets: '30 cibles',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Audit de conformité',
      slaGuarantee: 'SLA garanti 99.9%',
      dedicatedSupport: 'Support dédié',
      teamTraining: 'Formation équipe incluse',
      allEnterpriseFeatures: 'Tout le plan Entreprise +',
      unlimitedUsers: 'Utilisateurs illimités',
      fiftyTargets: '50 cibles',
      advancedWorkspaces: 'Multi-espaces avancés',
      whiteLabelReports: 'Rapports personnalisables',
      support24_7: 'Support dédié 24/7',
      accountManager: 'Gestionnaire de compte dédié',
      customOnboarding: 'Accompagnement personnalisé',
      allGroupeFeatures: 'Tout le plan Groupe +',
      dedicatedInfra: 'Infrastructure dédiée',
      customIntegrations: 'Intégrations personnalisées',
      specificDevelopment: 'Développements spécifiques',
      sourceCodeAudit: 'Audit de code source',
      manualPentest: 'Tests d\'intrusion manuels',
      cissoSupport: 'Accompagnement RSSI',
      customContract: 'Contrat sur mesure'
    },
    // Sections
    whyChoose: 'Pourquoi choisir SYLink Pentest\u202F?',
    aiTitle: 'Intelligence Artificielle',
    aiDesc: 'Notre IA analyse et exploite les vulnérabilités de manière autonome, simulant le comportement d\'un pentester expert.',
    securityTitle: 'Sécurité Maximale',
    securityDesc: 'Vos données sont chiffrées et sécurisées. Aucune information sensible n\'est stockée après les tests.',
    reportsTitle: 'Rapports Détaillés',
    reportsDesc: 'Générez des rapports PDF professionnels avec recommandations de remédiation et scoring CVSS.',
    // FAQ
    faqTitle: 'Questions fréquentes',
    faqCanChangePlan: 'Puis-je changer de plan\u202F?',
    faqCanChangePlanAnswer: 'Oui, vous pouvez upgrader ou downgrader votre plan à tout moment. Les changements sont effectifs immédiatement et au prorata.',
    faqFreePlan: 'Comment fonctionne le plan gratuit\u202F?',
    faqFreePlanAnswer: 'Le plan gratuit vous permet de tester la plateforme en mode simulation. Aucun scan réel n\'est effectué mais vous découvrez toutes les fonctionnalités.',
    faqCommitment: 'Y a-t-il un engagement\u202F?',
    faqCommitmentAnswer: 'Non, aucun engagement. Vous pouvez annuler à tout moment. La facturation annuelle offre 2 mois gratuits.',
    faqSupport: 'Quel support est inclus\u202F?',
    faqSupportAnswer: 'Le plan Pro inclut un support prioritaire par e-mail. Le plan Entreprise bénéficie d\'un support dédié 24/7.',
    // Contact CTA
    needHelpChoosing: 'Besoin d\'aide pour choisir\u202F?',
    needHelpDesc: 'Notre équipe est disponible pour vous conseiller et répondre à toutes vos questions. Obtenez une démonstration personnalisée de la plateforme.',
    contactUs: 'Contactez-nous',
    requestCall: 'Demander un appel',
    // Banners
    welcomeTitle: 'Bienvenue sur SYLink Pentest !',
    welcomeDesc: 'Votre compte est activé. Choisissez le plan qui correspond à vos besoins.',
    paymentError: 'Erreur de paiement',
    close: 'Fermer',
    redirecting: 'Redirection...',
    securedByStripe: 'Paiement sécurisé par Stripe'
  },

  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'Outils d\'attaque AD avec assistance IA LLM et PoC automatisé',
    domain: 'Domaine',
    dcIp: 'IP Domain Controller',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    ntlmHash: 'Hash NTLM (optionnel)',
    dcConfiguration: 'Configuration Domain Controller',
    attacks: 'Attaques AD',
    ldapPentest: 'Pentest LDAP/LDAPS',
    searchPlaceholder: 'Rechercher une attaque, un outil...',
    allCategories: 'Toutes les catégories',
    attackCategories: 'Catégories d\'Attaques',
    targetResults: 'Cible / Résultats',
    noDataMessage: 'Sélectionnez une attaque pour commencer',
    noDataHint: 'Ou utilisez le PoC Auto pour une chaîne d\'attaques',
    readyToStart: 'Prêt à démarrer',
    stats: {
      attacks: 'Attaques',
      successful: 'Réussies',
      failed: 'Échouées',
      credentials: 'Identifiants',
      users: 'Utilisateurs',
      paths: 'Chemins'
    },
    attackWizard: 'Assistant d\'Attaque AD'
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Plateforme de',
    platformSubtitle: 'Pentest Automatisé',
    platformDescription: 'Analyse de sécurité alimentée par l\'IA avec exploitation automatisée et rapports détaillés.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'IA Autonome',
      description: 'Pentester IA simulant un expert en sécurité',
      highlight: 'IA Locale'
    },
    advancedDetection: {
      title: 'Détection avancée',
      description: 'Détection automatique des failles critiques',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Tests complets',
      description: 'Audit réseau, web, API et infrastructure',
      highlight: '100+ outils'
    },
    instantReports: {
      title: 'Rapports instantanés',
      description: 'Génération automatique de rapports professionnels',
      highlight: '6+ formats'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Disponibilité',
    vulnerabilities: 'Vulnérabilités',
    monitoring: 'Surveillance',
    scanTime: 'Temps de scan'
  },

  // Footer
  footer: {
    title: 'Plateforme de scan de sécurité',
    subtitle: 'Système autonome de tests de pénétration',
    terms: 'Conditions générales d\'utilisation',
    termsShort: 'Conditions d\'utilisation (CGU)',
    sales: 'Conditions générales de vente',
    salesShort: 'Conditions de vente (CGV)',
    privacy: 'Politique de confidentialité',
    legalNotice: 'Mentions légales',
    contact: 'Contact',
    version: 'Version',
    licence: 'Licence n°',
    poweredBy: 'Propulsé par SYLink IA'
  },

  // Notifications
  notifications: {
    managementCenter: 'Centre de gestion des alertes et événements',
    aiAssistant: 'Assistant IA',
    aiAssistantTitle: 'Assistant IA - Notifications',
    aiPlaceholder: 'Posez une question sur vos notifications...',
    settings: 'Paramètres des notifications',
    soundEnabled: 'Sons activés',
    criticalOnly: 'Critiques seulement',
    autoMarkRead: 'Marquer lu auto',
    filters: 'Filtres',
    total: 'Total',
    unread: 'Non lues',
    critical: 'Critiques',
    warning: 'Attention',
    success: 'Succès',
    info: 'Infos',
    markAllRead: 'Tout marquer lu',
    clearAll: 'Effacer tout',
    noNotifications: 'Aucune notification',
    noNotificationsDesc: 'Vous n\'avez aucune notification pour le moment',
    allRead: 'Toutes vos notifications sont lues',
    noNotificationsType: 'Aucune notification de type "{type}"',

    // Notification types
    typeCritical: 'Critique',
    typeWarning: 'Attention',
    typeSuccess: 'Succès',
    typeInfo: 'Info',

    // Notification messages
    criticalVulnsFound: '{count} vulnérabilité{count, plural, =1 {} other {s}} critique{count, plural, =1 {} other {s}}',
    vulnsDetected: '{count} vulnérabilité{count, plural, =1 {} other {s}} détectée{count, plural, =1 {} other {s}}',
    hostsScanned: '{count} hosts scannés sur {target}',
    scanCompletedNoVulns: 'Scan terminé - Aucune vulnérabilité',
    noVulnsDetected: 'Aucune vulnérabilité détectée sur {target}',
    scanInProgress: 'Scan en cours',
    analyzing: 'Analyse de {target}...',
    scanFailed: 'Scan échoué',
    errorOn: 'Erreur sur {target}',

    // Time
    justNow: 'À l\'instant',
    minutesAgo: 'il y a {count}min',
    hoursAgo: 'il y a {count}h',
    daysAgo: 'il y a {count}j',
    scanRunning: 'Scan en cours',
    viewAll: 'Voir toutes les notifications',
    scanCompleted: 'Scan terminé'
  },

  // Enrichment - ABSpider Integration
  enrichment: {
    title: 'Enrichissement de données',
    subtitle: 'Analyse avancée de domaines et IPs avec VirusTotal, en-têtes de sécurité, e-mail et géolocalisation',
    description: 'Analysez des cibles avec plusieurs sources de renseignement de sécurité',

    // Flat keys used by EnrichmentDashboard
    target: 'Cible',
    type: 'Type',
    modules: 'Modules',
    quickScans: 'Scans rapides',
    threatSummary: 'Résumé des menaces',
    recentScans: 'Scans récents',
    riskScore: 'Score de risque',
    date: 'Date',
    noScans: 'Aucun scan pour le moment',
    scan: 'Analyser',
    quickResult: 'Résultat du scan rapide',
    scanDetails: 'Détails du scan',
    statusLabel: 'Statut',

    // Navigation & Actions
    newScan: 'Nouveau scan',
    quickScan: 'Scan rapide',
    fullScan: 'Scan complet',
    viewDetails: 'Voir les détails',
    exportReport: 'Exporter le rapport',
    refresh: 'Actualiser',

    // Scan Types
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'En-têtes de sécurité',
      security_headers: 'En-têtes de sécurité',
      email_security: 'Sécurité e-mail',
      geoip: 'Géolocalisation IP',
      reverse_ip: 'IP inversée',
      full: 'Scan complet',
      domain: 'Domaine',
      ip: 'Adresse IP',
      url: 'URL',
      // Pentest scan types
      ai_scan: 'Scan IA',
      network_discovery: 'Découverte réseau',
      vulnerability_scan: 'Scan de vulnérabilités',
      full_autonomous: 'Autonome complet',
      full_auto: 'Autonome complet',
      full_automation: 'Autonome complet',
      expert: 'Scan expert',
      api_pentest: 'Pentest API',
      iot_scan: 'Scan objets connectés',
      ot_scan: 'Scan OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Scan Active Directory',
      ad_recon: 'Reconnaissance AD',
      ad_full: 'Scan AD complet',
      ldap_scan: 'Scan LDAP',
      kerberos_scan: 'Scan Kerberos',
      web_scan: 'Scan Web',
      web: 'Scan Web',
      quick: 'Rapide',
      quick_scan: 'Scan rapide',
      discovery: 'Découverte',
      enumeration: 'Énumération',
      vulnerability: 'Vulnérabilités',
      exploitation: 'Exploitation',
      passive: 'Passif',
      aggressive: 'Agressif',
      credentials: 'Identifiants',
      recon: 'Reconnaissance',
      exploit: 'Exploitation',
      bypass: 'Contournement',
      nmap: 'Scan Nmap',
      nikto: 'Scan Nikto',
      internal: 'Scan interne',
      external: 'Scan externe',
      network: 'Scan réseau'
    },

    // Status
    status: {
      pending: 'En attente',
      queued: 'En file d\'attente',
      running: 'En cours',
      completed: 'Terminé',
      failed: 'Échoué',
      cancelled: 'Annulé'
    },

    // Threat Levels
    threatLevels: {
      safe: 'Sûre',
      low: 'Faible',
      medium: 'Moyenne',
      high: 'Élevée',
      critical: 'Critique'
    },

    // Form
    form: {
      targetDomain: 'Domaine cible',
      targetDomainPlaceholder: 'ex: exemple.com',
      targetIp: 'Adresse IP (optionnel)',
      targetIpPlaceholder: 'ex: 192.168.1.1',
      scanType: 'Type de scan',
      workspace: 'Espace de travail (optionnel)',
      startScan: 'Lancer le scan',
      credits: 'Crédits requis'
    },

    // Results - General
    results: {
      title: 'Résultats',
      noResults: 'Aucun résultat disponible',
      loading: 'Chargement des résultats...',
      riskScore: 'Score de risque',
      threatLevel: 'Niveau de menace',
      scannedAt: 'Scanné le',
      duration: 'Durée'
    },

    // Security Headers
    headers: {
      title: 'Analyse des en-têtes de sécurité',
      score: 'Score',
      grade: 'Note',
      present: 'Présents',
      missing: 'Manquants',
      recommendations: 'Recommandations',
      headerName: 'En-tête',
      value: 'Valeur',
      status: 'Statut',
      issues: 'Problèmes',
      gradeDescriptions: {
        A: 'Excellent - Sécurité optimale',
        B: 'Bon - Quelques améliorations possibles',
        C: 'Moyen - Améliorations recommandées',
        D: 'Faible - Améliorations importantes nécessaires',
        F: 'Insuffisant - Sécurité critique à améliorer'
      }
    },

    // Email Security
    email: {
      title: 'Sécurité e-mail',
      mxRecords: 'Enregistrements MX',
      spf: 'SPF (Sender Policy Framework)',
      dkim: 'DKIM (DomainKeys Identified Mail)',
      dmarc: 'DMARC (Domain-based Message Authentication)',
      valid: 'Valide',
      invalid: 'Invalide',
      notFound: 'Non trouvé',
      policy: 'Politique',
      mechanisms: 'Mécanismes',
      selectors: 'Sélecteurs',
      vulnerabilities: 'Vulnérabilités détectées',
      recommendations: 'Recommandations'
    },

    // GeoIP
    geoip: {
      title: 'Géolocalisation IP',
      location: 'Localisation',
      country: 'Pays',
      region: 'Région',
      city: 'Ville',
      coordinates: 'Coordonnées',
      timezone: 'Fuseau horaire',
      network: 'Informations réseau',
      isp: 'Fournisseur (ISP)',
      organization: 'Organisation',
      asn: 'ASN',
      flags: 'Indicateurs de sécurité',
      isProxy: 'Proxy détecté',
      isVpn: 'VPN détecté',
      isTor: 'Tor détecté',
      isDatacenter: 'Datacenter',
      isHosting: 'Hébergement'
    },

    // Reverse IP
    reverseIp: {
      title: 'Reverse IP Lookup',
      totalDomains: 'Domaines trouvés',
      domains: 'Liste des domaines',
      sharedHosting: 'Hébergement partagé',
      hostingProvider: 'Fournisseur d\'hébergement',
      suspiciousDomains: 'Domaines suspects',
      riskScore: 'Score de risque'
    },

    // VirusTotal
    virustotal: {
      title: 'Analyse VirusTotal',
      reputation: 'Réputation',
      malicious: 'Malveillant',
      suspicious: 'Suspect',
      harmless: 'Inoffensif',
      undetected: 'Non détecté',
      categories: 'Catégories',
      lastAnalysis: 'Dernière analyse',
      permalink: 'Lien VirusTotal'
    },

    // Dashboard Stats
    stats: {
      totalScans: 'Total des scans',
      completedScans: 'Scans terminés',
      pendingScans: 'Scans en attente',
      failedScans: 'Scans échoués',
      averageScore: 'Score moyen',
      criticalThreats: 'Menaces critiques',
      highThreats: 'Menaces élevées',
      creditsUsed: 'Crédits utilisés'
    },

    // Error messages (used by EnrichmentDashboard)
    error: {
      targetRequired: 'La cible est requise',
      scanFailed: 'Échec du démarrage du scan',
      quickScanFailed: 'Échec du scan rapide',
      loadFailed: 'Échec du chargement des détails du scan',
      deleteFailed: 'Échec de la suppression du scan'
    },

    // Success messages (used by EnrichmentDashboard)
    success: {
      scanStarted: 'Scan démarré avec succès',
      quickScanComplete: 'Scan rapide terminé',
      scanDeleted: 'Scan supprimé'
    },

    // Errors (legacy)
    errors: {
      scanFailed: 'Le scan a échoué',
      insufficientCredits: 'Crédits insuffisants',
      invalidDomain: 'Domaine invalide',
      invalidIp: 'Adresse IP invalide',
      networkError: 'Erreur réseau',
      timeout: 'Délai d\'attente dépassé',
      unknownError: 'Erreur inconnue'
    },

    // Tooltips
    tooltips: {
      virusTotalCredit: 'Utilise l\'API VirusTotal pour analyser la réputation',
      headersCredit: 'Analyse les headers HTTP de sécurité',
      emailCredit: 'Vérifie SPF, DKIM et DMARC',
      geoipCredit: 'Géolocalise l\'adresse IP',
      reverseIpCredit: 'Trouve les domaines hébergés sur la même IP',
      fullCredit: 'Effectue toutes les analyses'
    },

    // Recent Indicators
    recentIndicators: 'Indicateurs récents',

    // AI Analysis
    aiAnalysis: {
      title: 'Analyse IA',
      executiveSummary: 'Résumé exécutif',
      keyFindings: 'Points clés',
      recommendations: 'Recommandations'
    }
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Scanner Antivirus',
    subtitle: 'Analyser les fichiers contre les logiciels malveillants avec ClamAV',
    scannerTab: 'Scanner de fichiers',
    adminTab: 'Administration',
    adminTitle: 'Gestion Antivirus',
    adminSubtitle: 'Surveillance ClamAV et gestion de la quarantaine',
    scanFile: 'Scanner un fichier',
    scanNow: 'Scanner maintenant',
    scanAll: 'Scanner tous les fichiers',
    scanning: 'Analyse en cours...',
    dropOrClick: 'Déposer un fichier ou cliquer pour sélectionner',
    dropFiles: 'Déposer les fichiers ici ou cliquer pour sélectionner',
    maxSize: 'Taille maximale par fichier',
    selectedFiles: 'Fichiers sélectionnés',
    recentScans: 'Analyses récentes',
    summary: 'Résumé de l\'analyse',

    // Status
    clean: 'Sain',
    infected: 'Infecté',
    pending: 'En attente',
    unavailable: 'ClamAV indisponible',

    // Stats
    totalScans: 'Total des analyses',
    cleanFiles: 'Fichiers sains',
    infectedFiles: 'Fichiers infectés',
    dataScanned: 'Données analysées',
    threatsBySeverity: 'Menaces par sévérité',
    performance: 'Performance',
    avgScanTime: 'Temps moyen d\'analyse',
    cacheEntries: 'Entrées en cache',

    // Table headers
    filename: 'Nom du fichier',
    size: 'Taille',
    status: 'Statut',
    threat: 'Menace',
    severity: 'Sévérité',
    scannedAt: 'Analysé',

    // ClamAV
    daemonStatus: 'Statut du démon',
    version: 'Version',
    signatureVersion: 'Version des signatures',
    signatureCount: 'Signatures',
    reloadSignatures: 'Recharger les signatures',

    // Quarantine
    quarantine: 'Quarantaine',
    noQuarantine: 'Aucun fichier en quarantaine',
    quarantinedAt: 'Mis en quarantaine',
    expiresAt: 'Expire',
    cleanupExpired: 'Nettoyer les expirés',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer définitivement ce fichier\u202F?',

    // Errors
    fileTooLarge: 'Fichier trop volumineux',
    typeNotAllowed: 'Type de fichier non autorisé',
    total: 'Total'
  },

  // Contracts & Signature
  contracts: {
    title: 'Contrats',
    newContract: 'Nouveau contrat',
    contractNumber: 'Référence du contrat',
    status: 'Statut',
    draft: 'Brouillon',
    pendingSignature: 'En attente de signature',
    signed: 'Signé',
    active: 'Actif',
    completed: 'Terminé',
    expired: 'Expiré',
    cancelled: 'Annulé',

    // Signature
    signature: {
      title: 'Signature électronique',
      certificate: 'Certificat de signature électronique',
      signatory: 'Signataire',
      signatoryName: 'Nom du signataire',
      signatoryEmail: 'E-mail du signataire',
      signatoryFirstName: 'Prénom',
      signatoryLastName: 'Nom',
      signatureDate: 'Date et heure de signature',
      signatureType: 'Type de signature',
      drawn: 'Dessinée',
      typed: 'Saisie',
      uploaded: 'Téléversée',
      legalMention: 'Mention légale',
      acceptPentest: 'Bon pour acceptation de Pentest',

      // Verification
      verification: 'Vérification',
      smsVerification: 'Vérification SMS',
      smsVerified: 'Validée',
      smsPending: 'En attente',
      ipAddress: 'Adresse IP',
      userAgent: 'Navigateur',
      geolocation: 'Géolocalisation',

      // Integrity
      integrity: 'Intégrité du document',
      documentHash: 'Hash du document',
      signatureHash: 'Hash de la signature',
      hashAlgorithm: 'Algorithme',
      sha512: 'SHA-512',

      // Timeline
      timeline: 'Chronologie',
      createdAt: 'Créé le',
      sentAt: 'Envoyé le',
      viewedAt: 'Consulté le',
      signedAt: 'Signé le',
      viewCount: 'Nombre de consultations',

      // Audit trail
      auditTrail: 'Journal d\'audit',
      action: 'Action',
      timestamp: 'Horodatage',
      viewed: 'Consultation',
      smsRequested: 'Code SMS demandé',
      smsVerifiedAction: 'Code SMS vérifié',
      signedAction: 'Signature effectuée',
      downloaded: 'Téléchargement',

      // Certificate
      certificateType: 'CERTIFICAT DE SIGNATURE',
      platform: 'Plateforme',
      eidas: 'Signature électronique conforme au règlement eIDAS (UE) 910/2014',
      generatedAt: 'Certificat généré le',

      // Actions
      downloadProof: 'Télécharger la preuve de signature',
      viewCertificate: 'Voir le certificat',
      resendEmail: 'Renvoyer par e-mail',

      // Messages
      contractSigned: 'Contrat signé avec succès !',
      copySentByEmail: 'Une copie de ce certificat sera envoyée par e-mail.',
      enterSmsCode: 'Entrez le code SMS',
      smsCodeSent: 'Code SMS envoyé',
      invalidCode: 'Code invalide',
      codeExpired: 'Code expiré',
      tooManyAttempts: 'Trop de tentatives'
    }
  },

  // VPN Configuration
  vpn: {
    title: 'Configuration VPN',
    configurations: 'Configurations VPN',
    noConfigurations: 'Aucune configuration VPN',
    uploadConfig: 'Téléverser une configuration',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    connecting: 'Connexion en cours...',
    disconnecting: 'Déconnexion en cours...',
    connect: 'Connecter',
    disconnect: 'Déconnecter',
    server: 'Serveur',
    saveCredentials: 'Enregistrer les identifiants pour ce VPN',
    status: 'Statut VPN',
    protocol: 'Protocole',
    interface: 'Interface',
    publicIp: 'IP Publique',
    vpnIp: 'IP VPN',
    country: 'Pays',
    city: 'Ville',
    connectedSince: 'Connecté depuis',

    // Routes
    routes: {
      title: 'Routes Réseau',
      description: 'Gérez les routes réseau personnalisées pour le VPN',
      addRoute: 'Ajouter une route',
      destination: 'Destination CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Passerelle',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Description',
      routeDescriptionPlaceholder: 'Réseau interne client',
      noRoutes: 'Aucune route configurée',
      deleteRoute: 'Supprimer la route',
      applyRoutes: 'Appliquer les routes',
      routeAdded: 'Route ajoutée avec succès',
      routeDeleted: 'Route supprimée',
      routesApplied: 'Routes appliquées',
      invalidCidr: 'Format CIDR invalide',
      invalidGateway: 'Adresse IP invalide',
      active: 'Active',
      inactive: 'Inactive'
    },

    // Network Topology
    topology: {
      title: 'Topologie Réseau',
      server: 'Serveur Sylink',
      internet: 'Internet',
      vpnGateway: 'Passerelle VPN',
      clientNetwork: 'Réseau Client',
      online: 'En ligne',
      offline: 'Hors ligne',
      activeRoutes: 'Routes actives',
      totalRoutes: 'Routes totales',
      networkGateway: 'Passerelle Réseau',
      subnetsCount: '{{count}} sous-réseaux'
    },

    // Messages
    messages: {
      configUploaded: 'Configuration VPN téléversée',
      configDeleted: 'Configuration VPN supprimée',
      connectionSuccess: 'VPN connecté avec succès',
      connectionFailed: 'Échec de la connexion VPN',
      disconnectionSuccess: 'VPN déconnecté',
      disconnectionFailed: 'Échec de la déconnexion VPN'
    }
  },

  // Phishing Simulation
  phishing: {
    title: 'Simulation de Phishing',
    subtitle: 'Testez la sensibilisation à la sécurité des employés avec des campagnes de phishing simulées',
    campaignsTab: 'Campagnes',
    templatesTab: 'Modèles',
    targetsTab: 'Groupes cibles',
    analyticsTab: 'Statistiques',
    settingsTab: 'Paramètres',
    totalCampaigns: 'Total des campagnes',
    emailsSent: 'Emails envoyés',
    clickRate: 'Taux de clic',
    reportRate: 'Taux de signalement',
    recentCampaigns: 'Campagnes récentes',
    newCampaign: 'Nouvelle campagne',
    campaignName: 'Nom de la campagne',
    status: 'Statut',
    sent: 'Envoyés',
    opened: 'Ouverts',
    clicked: 'Cliqués',
    reported: 'Signalés',
    actions: 'Actions',
    viewDetails: 'Voir les détails',
    emailTemplates: 'Modèles d\'emails',
    createTemplate: 'Créer un modèle',
    targetGroups: 'Groupes cibles',
    createGroup: 'Créer un groupe',
    groupName: 'Nom du groupe',
    members: 'Membres',
    lastUsed: 'Dernière utilisation',
    edit: 'Modifier',
    delete: 'Supprimer',
    analyticsOverview: 'Vue d\'ensemble des analytiques',
    clickRateTrend: 'Tendance du taux de clic',
    reportRateTrend: 'Tendance du taux de signalement',
    chartPlaceholder: 'Le graphique s\'affichera ici',
    departmentComparison: 'Comparaison par département',
    settings: 'Paramètres du Phishing',
    smtpConfig: 'Configuration SMTP',
    smtpServer: 'Serveur SMTP',
    smtpPort: 'Port SMTP',
    trackingSettings: 'Paramètres de suivi',
    trackOpens: 'Suivre les ouvertures d\'emails',
    trackClicks: 'Suivre les clics sur les liens',
    trackSubmissions: 'Suivre les soumissions d\'identifiants',
    saveSettings: 'Enregistrer les paramètres',
    reference: 'Référence',
    statusCompleted: 'Terminé',
    statusActive: 'Active',
    statusScheduled: 'Planifiée',
    statusCancelled: 'Annulée',
    statusDraft: 'Brouillon',
    categoryCredentialHarvest: 'Collecte d\'identifiants',
    categoryLinkClick: 'Clic sur lien',
    categoryAttachment: 'Pièce jointe'
  },

  // Sankey Analysis
  sankey: {
    title: 'Diagramme de Flux de Sécurité',
    clickForAiAnalysis: 'Cliquez sur un élément pour l\'analyse IA',
    exploitable: 'Exploitable',
    nonExploitable: 'Non exploitable',
    columns: {
      workspaces: 'Espaces clients',
      targets: 'Cibles',
      assets: 'Actifs',
      vulnerabilities: 'Vulnérabilités',
      exploitability: 'Exploitabilité',
      cve: 'CVE'
    },
    legend: {
      workspaces: 'Espaces clients',
      targets: 'Cibles',
      critical: 'Critique',
      nonExploitable: 'Non exploit.'
    },
    severity: {
      critical: 'Critiques',
      high: 'Hautes',
      medium: 'Moyennes',
      low: 'Faibles'
    },
    analysis: {
      model: 'Modèle',
      changeModel: 'Analyser avec un autre LLM',
      selectModel: 'Sélectionner un modèle LLM',
      regenerateWith: "Régénérer l'analyse avec un autre modèle",
      recommended: 'Recommandé',
      regenerate: "Régénérer l'analyse"
    },
    noScansAvailable: 'Aucun scan disponible pour la visualisation',
    scansLabel: 'scans',
    hostsLabel: 'hôtes',
    portsLabel: 'ports',
    occurrences: 'occurrence(s)',
    tooltip: {
      element: 'Élément',
      scansHostsVulns: '{scans} scans • {hosts} hôtes • {vulns} vulnérabilités',
      ipHostsVulns: '{ip} • {hosts} hôtes • {vulns} vulnérabilités',
      vulnsCount: '{count} vulnérabilités',
      clickForAi: "Cliquez pour l'analyse IA"
    },
    stats: {
      workspaces: 'Espaces clients',
      targets: 'Cibles',
      assets: 'Actifs',
      vulnerabilities: 'Vulnérabilités',
      exploitable: 'Exploitable'
    }
  },

  // LLM Monitor
  llmMonitor: {
    title: 'Orchestrateur LLM',
    subtitle: 'Gestion et supervision des modèles avec accélération GPU',
    gpuStatus: 'Statut GPU',
    vram: 'VRAM',
    utilization: 'Utilisation',
    load: 'Charger',
    loaded: 'Chargé',
    noTarget: 'Aucune cible',
    entries: 'entrées',
    vulnerabilities: 'vulnérabilités',
    credentials: 'identifiants',
    poolStatus: 'Statut du Pool GPU',
    servers: 'serveurs',
    moreModels: 'de plus',
    orchestratorMetrics: 'Métriques de l\'Orchestrateur',
    totalRequests: 'Requêtes Totales',
    modelSwaps: 'Échanges de Modèle',
    avgSwapTime: 'Temps Moy. Échange',
    inferences: 'Inférences',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    refresh: 'Actualiser',
    availableModels: 'Modèles Disponibles',
    activeSessions: 'Sessions Actives',
    noActiveSessions: 'Aucune session active',
    noSessionsHint: 'Les sessions LLM utilisent l\'intelligence artificielle pour analyser automatiquement les vulnérabilités, générer des rapports et coordonner les tests de pénétration.',
    noSessionsAction: 'Démarrer une session',
    readyStatus: 'Prêt à démarrer',
    howToStart: 'Lancez un scan pour démarrer une session LLM',
    waitingForScan: 'En attente d\'un scan',
    quickActions: 'Actions Rapides',
    newSession: 'Nouvelle Session',
    requestCheckpoint: 'Demander un Checkpoint',
    hashcatTasks: 'Tâches Hashcat',
    loadStatusFailed: 'Échec du chargement du statut LLM',
    loadingModel: 'Chargement de {{model}}...',
    swapFailed: 'Échec du changement de modèle',
    noModel: 'Aucun',
    online: 'En ligne',
    offline: 'Hors ligne',
    serviceUnavailable: 'Service LLM indisponible'
  },

  // Tool Categories (for ToolsList)
  toolCategories: {
    reconnaissance: 'Reconnaissance',
    web: 'Scan Web',
    cms: 'Scanners CMS',
    vulnerabilities: 'Scanners de Vulnérabilités',
    bruteforce: 'Force Brute',
    ad: 'Active Directory',
    ldap: 'LDAP / LDAPS',
    services: 'Énumération de Services',
    osint: 'Renseignement en sources ouvertes (OSINT)',
    suites: 'Suites de Sécurité',
    ssl: 'SSL/TLS',
    ot: 'OT/ICS/SCADA',
    iot: 'Appareils IoT',
    pivoting: 'Pivoting & Tunneling',
    privesc: 'Élévation de Privilèges',
    evasion: 'Évasion & Contournement',
    supply_chain: 'Sécurité Supply Chain',
    network_attack: 'Attaques Réseau',
    firewall: 'Box / Pare-feu / Routeur',
    vpn: 'Sécurité VPN',
    cloud: 'Sécurité Cloud',
    other: 'Autres'
  },

  // OSINT translations (used by ScansList.jsx translateScanType)
  osint: {
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'En-têtes de sécurité',
      security_headers: 'En-têtes de sécurité',
      email_security: 'Sécurité e-mail',
      geoip: 'Géolocalisation IP',
      reverse_ip: 'IP inversée',
      full: 'Scan complet',
      domain: 'Domaine',
      ip: 'Adresse IP',
      url: 'URL',
      network_discovery: 'Découverte réseau',
      vulnerability_scan: 'Scan de vulnérabilités',
      full_autonomous: 'Autonome complet',
      full_auto: 'Autonome complet',
      full_automation: 'Autonome complet',
      expert: 'Scan expert',
      api_pentest: 'Pentest API',
      iot_scan: 'Scan objets connectés',
      ot_scan: 'Scan OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Scan Active Directory',
      ad_recon: 'Reconnaissance AD',
      ad_full: 'Scan AD complet',
      ldap_scan: 'Scan LDAP',
      kerberos_scan: 'Scan Kerberos',
      web_scan: 'Scan Web',
      web: 'Scan Web',
      quick: 'Rapide',
      quick_scan: 'Scan rapide',
      discovery: 'Découverte',
      enumeration: 'Énumération',
      vulnerability: 'Vulnérabilités',
      exploitation: 'Exploitation',
      passive: 'Passif',
      aggressive: 'Agressif',
      credentials: 'Identifiants',
      recon: 'Reconnaissance',
      exploit: 'Exploitation',
      bypass: 'Contournement',
      nmap: 'Scan Nmap',
      nikto: 'Scan Nikto',
      internal: 'Scan interne',
      external: 'Scan externe',
      network: 'Scan réseau',
      // OWASP/ZAP related scan types
      owasp: 'Scan OWASP',
      owasp_scan: 'Scan OWASP',
      owasp_top10: 'OWASP Top 10',
      owasp_top_10: 'OWASP Top 10',
      zap: 'Scan ZAP',
      zap_scan: 'Scan ZAP',
      owasp_zap: 'Scan OWASP ZAP',
      // Additional scan types
      sqlmap: 'Scan SQLMap',
      openvas: 'Scan OpenVAS',
      nuclei: 'Scan Nuclei',
      metasploit: 'Scan Metasploit',
      hydra: 'Test Hydra',
      wpscan: 'Scan WordPress',
      gobuster: 'Scan Gobuster',
      pentest: 'Pentest',
      stealth: 'Scan furtif',
      full_scan: 'Scan complet',
      standard: 'Standard'
    }
  }
};
